import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { filter, size, split, replace, sumBy } from 'lodash';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Form from 'reactstrap/lib/Form';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import Input from 'reactstrap/lib/Input';
import Button from 'reactstrap/lib/Button';
import Media from 'reactstrap/lib/Media';
import Pagination from 'reactstrap/lib/Pagination';
import PaginationItem from 'reactstrap/lib/PaginationItem';
import PaginationLink from 'reactstrap/lib/PaginationLink';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';

import FileUploadImage from './components/FileUploadImage';
import FileUploadPrizeImage from './components/FileUploadPrizeImage';

import moment from 'moment';
import Moment from 'react-moment';

import DateTimePicker from 'react-widgets/lib/DateTimePicker';

import momentLocalizer from 'react-widgets-moment';
import 'react-widgets/dist/css/react-widgets.css';

import closeImg from '../../../images/icons/close.png';

import {
  TOURNAMENT_OPTION_IMAGES, CALC_TOURNAMENT_ROUND_LENGTH,
} from '../../../constants/constants'

import {
  answerSupportMessage,
  cancelUserMessages,
  getUserMessages,
  supportMessageFileUpload,
} from '../../../actions/admin';
import { PopoverBody, UncontrolledPopover } from 'reactstrap';

import ScrollAreaWrapper from '../UI/ScrollAreaWrapper';

import isEqual from 'react-fast-compare';
import { formatMinutes } from '../../../utils/stringUtils';
import Chat from './Modals/Chat';
import LeaveReason from './Modals/LeaveReason';
import PlayerHistory from './Modals/PlayerHistory';
import TournamentPlayers from './Modals/TournamentPlayers';
import TournamentResults from './Modals/TournamentResults';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import DatePanel from 'react-multi-date-picker/plugins/date_panel';
import { changeDateFormat } from '../../../utils/dateUtils';

moment.locale('lv');
momentLocalizer();

class AllBans extends React.Component {
  static propTypes = {
    member: PropTypes.shape({
      email: PropTypes.string,
    }),
    allTournaments: PropTypes.shape({}),
    tournamentPlayers: PropTypes.arrayOf(PropTypes.shape({})),
    tournamentPlayerHistory: PropTypes.shape({}),
    tournamentResults: PropTypes.arrayOf(PropTypes.shape({})),
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    editTournament: PropTypes.func.isRequired,
    addTournament: PropTypes.func.isRequired,
    deleteTournament: PropTypes.func.isRequired,
    fetchTournamentPlayers: PropTypes.func.isRequired,
    fetchTournamentResults: PropTypes.func.isRequired,
    fetchTournamentPlayerHistory: PropTypes.func.isRequired,
    forceCloseTournament: PropTypes.func.isRequired,
    showNotification: PropTypes.func.isRequired,
    supportAMessageFileUpload : PropTypes.func.isRequired,
  }

  static defaultProps = {
    member: {},
    allTournaments: {},
    tournamentPlayers: [],
    tournamentResults: [],
    tournamentPlayerHistory: {},
  }

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 0,
      pageSize: 50,
      tournamentToEdit: '',
      openModal: false,
      deleteModal: false,
      deleteModalSelectedTournament: '',
      openPlayersModal: false,
      name: '',
      bet: '1:100',
      entryFee: 1000,
      playerPerRoomLimit: 3,
      bonus: 3000,
      //  startDate: moment(),
      startDate: new Date(),
      bannerStartDate: new Date(Date.now() - 3 * 60 * 60 * 1000),
      bannerEndDate: new Date(),
      winnerPercent: 25,
      parasta: true,
      G: false,
      atra: false,
      veryFast: true,
      lightning: false,
      unlimited: false,
      pro: false,
      maza: false,
      maxPlayers: 1000,
      rounds: null,
      roundLength: null,
      newRoundPause: null,
      playersModalId: '',
      registerTime: null,
      registerDateTime: new Date(),
      openPlayerHistoryModal: false,
      password: null,
      privateTournament: false,
      devTournament: false,

      sponsorPreview: null,
      sponsorImageUrl: '',
      sponsorShowCrop: false,
      sponsorUploadFile: null,

      prizePreview: null,
      prizeImageUrl: '',
      prizeShowCrop: false,
      prizeUploadFile: false,

      bannerPrizePreview: null,
      bannerPrizeImageUrl: '',
      bannerPrizeShowCrop: false,
      bannerPrizeUploadFile: false,

      loading: false,
      playerHistoryId: null,

      openChatModal: false,
      openChatModalName: '',
      openChatModalUid: '',

      inputMessage: '',
      ableToSend: true,
      bannerPrizeChecked: false,
      bannerShowChecked: true,
      repetitiveTournament: false,

      leaveReasonModal: null,
      openedPlayerTournament: '',

      environment: 'all',
      filteredAllTournaments: this.getFilteredTournaments(props.allTournaments, 'all'),
      tournamentType: 'regular',
      multiDates: [/*new DateObject()*/],
      maxMultiDates: 25,

      restrictions: false,
      levelFrom: null,
      levelTo: null,
      pointsFrom: null,
      pointsTo: null,
      balanceFrom: null,
      balanceTo: null,
      playedGamesFrom: null,
      playedGamesTo: null,
      popInfoKey: '',
      more: false,
      selectedUsers: [],
      openChatModalMultiple: false,
      tournamentsPerDate: {},
    };

    this.handleClick = this.handleClick.bind(this);
    this.openModal = this.openModal.bind(this);
    this.openAddModal = this.openAddModal.bind(this);
    this.editTournament = this.editTournament.bind(this);
    this.addTournament = this.addTournament.bind(this);

    this.sponsorHiddenFileInput = React.createRef(null);
    this.sponsorHandleEditPhoto = this.sponsorHandleEditPhoto.bind(this);
    this.sponsorOnCrop = this.sponsorOnCrop.bind(this);

    this.prizeHiddenFileInput = React.createRef(null);
    this.prizeHandleEditPhoto = this.prizeHandleEditPhoto.bind(this);
    this.prizeOnCrop = this.prizeOnCrop.bind(this);

    this.bannerPrizeHiddenFileInput = React.createRef(null);
    this.bannerPrizeHandleEditPhoto = this.bannerPrizeHandleEditPhoto.bind(this);
    this.bannerPrizeOnCrop = this.bannerPrizeOnCrop.bind(this);

    this.datePickerRef = React.createRef();

  }

  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(prevProps.allTournaments, this.props.allTournaments) || prevState.environment !== this.state.environment) {
      this.setState({
        filteredAllTournaments: this.getFilteredTournaments(this.props.allTournaments, this.state.environment),

      });
    }

    if (!isEqual(prevProps.allTournaments, this.props.allTournaments)) {

      this.setState({ tournamentsPerDate: this.getTournamentsPerDate(this.props.allTournaments)});
    }
  }

  getTournamentsPerDate = (allTournaments) => {
    const now = Date.now();
    const tournamentsPerDate = {};

    Object.values(allTournaments)
      .filter(t => t.startDate >= now /*&& !t.devTournament*/)
      .forEach(t => {
        const dateKey = changeDateFormat(t.startDate, '/');

        const dateObj = new Date(t.startDate);
        const hours = String(dateObj.getHours()).padStart(2, '0');
        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
        const timeFormatted = `${hours}:${minutes}`;

        if (!tournamentsPerDate[dateKey]) {
          tournamentsPerDate[dateKey] = [];
        }

        tournamentsPerDate[dateKey].push({
          title: t.titleEN,
          time: timeFormatted,
        });
      });

    Object.keys(tournamentsPerDate).forEach(date => {
      tournamentsPerDate[date].sort((a, b) => a.time.localeCompare(b.time));
    });

    return tournamentsPerDate;
  };



  toggleDatePicker = () => {
    if (this.datePickerRef.current) {
      if (this.datePickerRef.current.isOpen) {
        this.datePickerRef.current.closeCalendar();
      } else {
        this.datePickerRef.current.openCalendar();
      }
    }
  };

  getMaxLengthTime = (roundLength, rounds, newRoundPause) => {
    const { lightning, atra, veryFast } = this.state;
    let roundLengthTime = 20;

    /* if (roundLength > 24) {
      roundLengthTime = 60;
    } else if (roundLength > 12) {
      roundLengthTime = 40;
    } */

    console.log('getMaxLengthTime', roundLength, rounds, newRoundPause, lightning, atra, veryFast);

    let speed = 'parasta';

    if (lightning) {
      speed = 'lightning';
    } else if (atra) {
      speed = 'atra';
    } else if (veryFast) {
      speed = 'veryFast';
    }

    roundLengthTime = CALC_TOURNAMENT_ROUND_LENGTH(roundLength, speed);

    console.log('roundLengthTime', roundLengthTime);

    const maxLengthTime = (roundLengthTime * rounds) + (newRoundPause * (rounds - 1));

    console.log('maxLengthTime final', maxLengthTime);

    return Math.ceil(maxLengthTime / 10) * 10;
  }

  handleChange = (event) => {
    let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

    const maxLengthChanged = event.target.name === 'roundLength' || event.target.name === 'rounds' || event.target.name === 'newRoundPause';

    if (maxLengthChanged) {
      const { roundLength, rounds, newRoundPause } = this.state;
      const roundLengthTemp = event.target.name === "roundLength" ? event.target.value : roundLength;
      const roundsTemp = event.target.name === "rounds" ? event.target.value : rounds;
      const newRoundPauseTemp = event.target.name === "newRoundPause" ? event.target.value : newRoundPause;

      this.setState({
        [event.target.name]: value,
        maxLengthTime: this.getMaxLengthTime(roundLengthTemp, roundsTemp, newRoundPauseTemp),
      });
    } else {
      if ([
          'pointsFrom', 'pointsTo',
          'balanceFrom', 'balanceTo'].includes(event.target.name)
        ) {
            value = value.replace(/(?!^)-|[^0-9-]/g, '');

            if (value.startsWith('-')) {
              value = value.slice(0, 11);
            } else {
              value = value.slice(0, 10);
            }
        } else if ([
          'levelFrom', 'levelTo',
          'playedGamesFrom', 'playedGamesTo'].includes(event.target.name)
        ) {
          value = value.replace(/\D/g, '');
          value = value.slice(0, 10);
        } else if (event.target.name === 'password') {
        if (value.length > 4) {
          value = value.slice(0, 4);
        }
      }
      this.setState({
        [event.target.name]: value,
      });
    }

    if (event.target.name === 'restrictions' && !value) {
      console.log(event.target.name, value, "check event target name")
      this.setState({
        levelFrom: '',
        levelTo: '',
        pointsFrom: '',
        pointsTo: '',
        balanceFrom: '',
        balanceTo: '',
        playedGamesFrom: '',
        playedGamesTo: '',
      })
    }
  }

  ChangeStartDate = (date) => {
    const { registerDateTime } = this.state;
    this.setState({
      startDate: date,
      registerTime: Math.floor((date - registerDateTime) / 1000 / 60),
      bannerEndDate: date,
    });
  }

  ChangeBannerStartDate = (date) => {
    this.setState({
      bannerStartDate: date,
    });
  }
  ChangeBannerEndDate = (date) => {
    this.setState({
      bannerEndDate: date,
    });
  }

  changeRegisterDateTime = (date) => {
    const { startDate } = this.state;
    this.setState({
      registerDateTime: date,
      registerTime: Math.floor((startDate - date) / 1000 / 60),
      //when adding tournament set correct register time value OR when changing registerDateTime and startDate
    });
  }

  openModal = (id) => {
    const { allTournaments } = this.props;
    const tournament = allTournaments[id];

    let parasta;
    let G;
    if (tournament.gameType === 'G') {
      parasta = false;
      G = true;
    } else {
      parasta = true;
      G = false;
    }

    console.log('openModal', tournament);

    if (tournament) {
      this.setState({
        tournamentToEdit: id,
        openModal: true,
        openAddModal: false,
        deleteModal: false,
        openPlayersModal: false,
        name: tournament.name,
        titleLV: tournament.titleLV,
        titleEN: tournament.titleEN,
        titleRU: tournament.titleRU,
        bet: tournament.bet,
        entryFee: tournament.entryFee || 1000,
        playerPerRoomLimit: tournament.playerPerRoomLimit || 'none',
        bonus: tournament.bonus || 0,
        //  startTime: new Date(tournament.startTime),
        startDate: new Date(tournament.startDate),
        bannerStartDate: tournament.bannerStartDate ? new Date(tournament.bannerStartDate) : new Date(Date.now() - 3 * 60 * 60 * 1000),
        bannerEndDate: tournament.bannerEndDate ? new Date(tournament.bannerEndDate) : new Date(),
        registerTime: tournament.registerTime,
        registerDateTime: new Date(new Date(tournament.startDate).getTime() - tournament.registerTime * 60000),
        maxLengthTime: tournament.maxLengthTime,
        winnerPercent: tournament.winnerPercent || 25,
        parasta,
        G,
        atra: !!tournament.fastGame,
        veryFast: !!tournament.veryFastGame,
        lightning: !!tournament.lightningGame,
        unlimited: !!tournament.unlimitedGame,
        pro: !!tournament.proGame,
        maza: !!tournament.smallGame,
        maxPlayers: tournament.maxPlayers || 1000,
        rounds: tournament.rounds || null,
        roundLength: tournament.roundLength || null,
        newRoundPause: tournament.newRoundPause || null,
        privateTournament: tournament.privateTournament || null,
        devTournament: tournament.devTournament || null,
        password: tournament.password || null,
        sponsorImageUrl: tournament.sponsorImg || '',
        sponsorPreview: null,
        prizeImageUrl: tournament.prizeImg || '',
        prizePreview: null,

        bannerPrizeImageUrl: tournament.bannerPrizeImageUrl || '',
        bannerPrizeChecked: tournament.bannerPrizeChecked || false,
        bannerPrizePreview: null,
        bannerPrizeUploadFile: null,
        bannerShowChecked: tournament.bannerShowChecked,

        specialPrizeLV: tournament.specialPrizeLV,
        specialPrizeEN: tournament.specialPrizeEN,
        specialPrizeRU: tournament.specialPrizeRU,

        tournamentType: tournament?.tournamentType || 'regular',
        restrictions: tournament.restrictions || false,
        levelFrom: tournament.levelFrom ? parseInt(tournament.levelFrom || 0) : null,
        levelTo: tournament.levelTo ? parseInt(tournament.levelTo || 0) : null,
        pointsFrom: tournament.pointsFrom ? parseInt(tournament.pointsFrom || 0) : null,
        pointsTo: tournament.pointsTo ? parseInt(tournament.pointsTo || 0) : null,
        balanceFrom: tournament.balanceFrom ? parseInt(tournament.balanceFrom || 0) : null,
        balanceTo: tournament.balanceTo ? parseInt(tournament.balanceTo || 0) : null,
        playedGamesFrom: tournament.playedGamesFrom ? parseInt(tournament.playedGamesFrom || 0) : null,
        playedGamesTo: tournament.playedGamesTo ? parseInt(tournament.playedGamesTo || 0) : null,
      });
    }
  }

  openAddModal = () => {
    this.setState({
      openModal: false,
      openAddModal: true,
      deleteModal: false,
      openPlayersModal: false,
      name: '',
      titleLV: '',
      titleEN: '',
      titleRU: '',
      bet: '1:100',
      entryFee: 1000,
      playerPerRoomLimit: 3,
      bonus: 3000,
      //  startTime: new Date(),
      startDate: new Date(),
      bannerStartDate: new Date(Date.now() - 3 * 60 * 60 * 1000),
      bannerEndDate: new Date(),
      registerTime: new Date(),
      registerDateTime: new Date(),
      maxLengthTime: this.getMaxLengthTime(12, 4, 2),
      winnerPercent: 25,
      parasta: true,
      G: false,
      atra: false,
      veryFast: true,
      lightning: false,
      unlimited: false,
      pro: false,
      maza: false,
      maxPlayers: 1000,
      rounds: 4,
      roundLength: 12,
      newRoundPause: 1,
      privateTournament: false,
      devTournament: false,
      password: null,
      sponsorImageUrl: '',
      sponsorUploadFile: null,
      sponsorPreview: null,
      prizeImageUrl: '',
      prizePreview: null,
      prizeUploadFile: null,

      bannerPrizeImageUrl: '',
      bannerPrizeChecked: false,
      bannerPrizePreview: null,
      bannerPrizeUploadFile: null,
      bannerShowChecked: true,

      specialPrizeLV: '',
      specialPrizeEN: '',
      specialPrizeRU: '',

      tournamentType: 'regular',

      restrictions: false,
      levelFrom: null,
      levelTo: null,
      pointsFrom: null,
      pointsTo: null,
      balanceFrom: null,
      balanceTo: null,
      playedGamesFrom: null,
      playedGamesTo: null,

      multiDates: [/*new DateObject()*/],
      repetitiveTournament: false,
    });
  }

  openPlayersModal = (id, tournamentState) => {
    const { fetchTournamentPlayers } = this.props;

    fetchTournamentPlayers(id, tournamentState);
    this.setState({
      openModal: false,
      openAddModal: false,
      openPlayersModal: true,
      openResultsModal: false,
      playersModalId: id,
      openedPlayerTournament: tournamentState,
    });
  }

  openPlayerHistoryModalFunc = (tournamentId, playerId) => {
    console.log('openPlayerHistoryModal');
    const { fetchTournamentPlayerHistory } = this.props;
    //  const { playersModalId } = this.state;

    fetchTournamentPlayerHistory(tournamentId, playerId);
    this.setState({
      openPlayerHistoryModal: true,
      playerHistoryId: playerId,
    //  openModal: false,
    //  openAddModal: false,
    //  openPlayersModal: true,
    //  openResultsModal: false,
    //  playersModalId: id,
    });
  }


  openResultsModal = (id) => {
    const { fetchTournamentResults, fetchBots } = this.props;

    fetchTournamentResults(id);
    fetchBots();

    this.setState({
      openModal: false,
      openAddModal: false,
      openPlayersModal: false,
      openResultsModal: true,
    });
  }

  togglePlayers = () => {
    this.setState(prevState => ({
      openPlayersModal: !prevState.openPlayersModal,
      playersModalId: '',
      openedPlayerTournament: ''
    }));
  }

  togglePlayerHistory = () => {
    this.setState(prevState => ({
      openPlayerHistoryModal: !prevState.openPlayerHistoryModal,
    }));
  }

  toggleResults = () => {
    this.setState(prevState => ({
      openResultsModal: !prevState.openResultsModal,
    }));
  }

  toggleDeleteModal = (id) => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
      forceCloseModal: false,
      deleteModalSelectedTournament: id,
    }));
  }

  deleteTournament = () => {
    const { deleteTournament } = this.props;
    const { deleteModalSelectedTournament } = this.state;

    if (deleteModalSelectedTournament) {
      deleteTournament(deleteModalSelectedTournament);

      this.setState({
        deleteModal: false,
        deleteModalSelectedTournament: '',
      });
    }
  }

  toggleForceCloseTournament = (id) => {
    this.setState(prevState => ({
      forceCloseModal: !prevState.forceCloseModal,
      deleteModal: false,
      forceCloseModalSelectedTournament: id,
    }));
  }

  forceCloseTournament = () => {
    const { forceCloseTournament } = this.props;
    const { forceCloseModalSelectedTournament } = this.state;

    if (forceCloseModalSelectedTournament) {
      forceCloseTournament(forceCloseModalSelectedTournament);

      this.setState({
        forceCloseModal: false,
        forceCloseModalSelectedTournament: '',
      });
    }
  }

  editTournament = () => {
    const { editTournament, allTournaments, showNotification } = this.props;
    const {
      tournamentToEdit,
      sponsorImageUrl,
      prizeImageUrl,
      name,
      titleLV,
      titleEN,
      titleRU,
      entryFee,
      bonus,
      startDate,
      registerTime,
      winnerPercent,
      parasta,
      G,
      atra,
      veryFast,
      lightning,
      unlimited,
      pro,
      maxPlayers,
      maza,
      rounds, roundLength,
      newRoundPause,
      bet,
      password,
      privateTournament,
      devTournament,
      playerPerRoomLimit,
      bannerPrizeChecked,
      bannerPrizeImageUrl,
      bannerShowChecked,
      bannerStartDate,
      bannerEndDate,
      specialPrizeEN,
      specialPrizeLV,
      specialPrizeRU,
      tournamentType,
      restrictions,
      levelFrom,
      levelTo,
      pointsFrom,
      pointsTo,
      balanceFrom,
      balanceTo,
      playedGamesFrom,
      playedGamesTo,
    } = this.state;

    const tournament = allTournaments[tournamentToEdit];

    const prevState = tournament.currentState || null;

    console.log("editTournament", tournamentToEdit, sponsorImageUrl, prizeImageUrl, name, titleLV, titleEN, titleRU, entryFee, bonus, startDate, registerTime, winnerPercent, parasta, G, atra, veryFast, lightning, unlimited, pro, maxPlayers, maza, rounds, roundLength, newRoundPause, bet, password, privateTournament, devTournament, playerPerRoomLimit, bannerPrizeChecked, bannerPrizeImageUrl, bannerShowChecked, bannerStartDate, bannerEndDate);

    if (bannerPrizeChecked && !bannerPrizeImageUrl) {
      showNotification('Error!', "Prize banner must be selected", 'danger');
      return;
    }
    editTournament({
      data: {
        tournamentToEdit,
        sponsorImageUrl,
        prizeImageUrl,
        titleLV,
        titleEN,
        titleRU,
        entryFee,
        bonus,
        startDate,
        registerTime,
        winnerPercent,
        parasta,
        G,
        atra,
        veryFast,
        lightning,
        unlimited,
        pro,
        maxPlayers,
        maza,
        rounds,
        roundLength,
        newRoundPause,
        bet,
        password,
        privateTournament,
        devTournament,
        playerPerRoomLimit,
        bannerPrizeChecked,
        bannerPrizeImageUrl,
        bannerShowChecked,
        bannerStartDate,
        bannerEndDate,
        specialPrizeEN,
        specialPrizeLV,
        specialPrizeRU,
        tournamentType,
        restrictions,
        levelFrom,
        levelTo,
        pointsFrom,
        pointsTo,
        balanceFrom,
        balanceTo,
        playedGamesFrom,
        playedGamesTo,
      },
      oldData: tournament,
    }).then((res) => {
      console.log('editTournament res', res);
      this.setState({ openModal: false });
    }).catch((err) => {
      console.log('editTournament err', err);
    });

  //  this.setState({ openModal: false });
  }


  // addTournament() {
  //   const { addTournament } = this.props;
  //   const {
  //     tournamentToEdit, sponsorImageUrl, prizeImageUrl, name, entryFee, bonus, startDate, registerTime, winnerPercent, parasta, G, atra, lightning, unlimited, pro, maxPlayers, maza, rounds, roundLength, newRoundPause, bet, password, privateTournament, devTournament,
  //   } = this.state;

  //   addTournament({
  //     tournamentToEdit, sponsorImageUrl, prizeImageUrl, name, entryFee, bonus, startDate, registerTime, winnerPercent, parasta, G, atra, lightning, unlimited, pro, maxPlayers, maza, rounds, roundLength, newRoundPause, bet, password, privateTournament, devTournament,
  //   }).then((res) => {
  //     console.log('addTournament res', res);
  //     this.setState({ openAddModal: false });
  //   }).catch((err) => {
  //     console.log('addTournament err', err);
  //   });

  // //  this.setState({ openAddModal: false });
  // }

  async addTournament() {
    try {
      const { addTournament, showNotification } = this.props;
      const {
        tournamentToEdit,
        sponsorImageUrl,
        prizeImageUrl,
        name,
        titleLV,
        titleEN,
        titleRU,
        entryFee,
        bonus,
        startDate,
        registerTime,
        winnerPercent,
        parasta,
        G,
        atra,
        veryFast,
        lightning,
        unlimited,
        pro,
        maxPlayers,
        maza,
        rounds, roundLength,
        newRoundPause,
        bet,
        password,
        privateTournament,
        devTournament,
        playerPerRoomLimit,
        bannerPrizeChecked,
        bannerPrizeImageUrl,
        bannerShowChecked,
        bannerStartDate,
        bannerEndDate,
        specialPrizeLV,
        specialPrizeEN,
        specialPrizeRU,
        tournamentType,
        repetitiveTournament,
        multiDates,
        restrictions,
        levelFrom,
        levelTo,
        pointsFrom,
        pointsTo,
        balanceFrom,
        balanceTo,
        playedGamesFrom,
        playedGamesTo,
      } = this.state;

      if (bannerPrizeChecked && !bannerPrizeImageUrl) {
        showNotification('Error!', "Prize banner must be selected", 'danger');
        return;
      }

      console.log("addTournament", tournamentToEdit, sponsorImageUrl, prizeImageUrl, name, titleLV, titleEN, titleRU, entryFee, bonus, {startDate}, {registerTime},  {repetitiveTournament}, {multiDates}, winnerPercent, parasta, G, atra, lightning, unlimited, pro, maxPlayers, maza, rounds, roundLength, newRoundPause, bet, password, privateTournament, devTournament, playerPerRoomLimit, bannerPrizeChecked, bannerPrizeImageUrl, bannerShowChecked, bannerStartDate, bannerEndDate);

      const res = await addTournament({
        tournamentToEdit,
        sponsorImageUrl,
        prizeImageUrl,
        titleLV,
        titleEN,
        titleRU,
        entryFee,
        bonus,
        startDate,
        registerTime,
        winnerPercent,
        parasta,
        G,
        atra,
        veryFast,
        lightning,
        unlimited,
        pro,
        maxPlayers,
        maza,
        rounds,
        roundLength,
        newRoundPause,
        bet,
        password,
        privateTournament,
        devTournament,
        playerPerRoomLimit,
        bannerPrizeChecked,
        bannerPrizeImageUrl,
        bannerShowChecked,
        bannerStartDate,
        bannerEndDate,
        specialPrizeLV,
        specialPrizeEN,
        specialPrizeRU,
        tournamentType,
        repetitiveTournament,
        multiDates,
        restrictions,
        levelFrom,
        levelTo,
        pointsFrom,
        pointsTo,
        balanceFrom,
        balanceTo,
        playedGamesFrom,
        playedGamesTo,
      });
      this.setState({ openAddModal: false });

      console.log('addTournament res', res);
    } catch (err) {
      console.log('addTournament err', err);
    }
  }

  toggleAdd = () => {
    this.setState(prevState => ({
      openAddModal: !prevState.openAddModal,
    }));
  }

  toggle = () => {
    this.setState(prevState => ({
      openModal: !prevState.openModal,
    }));
  }

  toggleResultRound = (index) => {
    this.setState({ openResultsRound: index });
  }

  toggleGameType = async (type) => {
    if (type === 'parasta') {
      this.setState(prevState => ({ parasta: !prevState.parasta, G: prevState.parasta }));
    } else if (type === 'G') {
      this.setState(prevState => ({ parasta: prevState.G, G: !prevState.G }));
    } else {
      const { roundLength, rounds, newRoundPause } = this.state;

      if (type === 'lightning') {
        await this.setState(prevState => ({
          [type]: !prevState[type],
          atra: false,
        }));
      } else if (type === 'atra') {
        await this.setState(prevState => ({
          [type]: !prevState[type],
          lightning: false,
        }));
      } else if (type === 'unlimited') {
        await this.setState(prevState => ({
          [type]: !prevState[type],
          unlimited: false,
        }));
      } else {
        await this.setState(prevState => ({ [type]: !prevState[type] }));
      }

      // this.getMaxLengthTime(roundLength, rounds, newRoundPause);

      this.setState({
        maxLengthTime: this.getMaxLengthTime(roundLength, rounds, newRoundPause),
      });
    }
  }

  toggleGameSpeed = async (speed) => {
    const { roundLength, rounds, newRoundPause } = this.state;

    if (speed === 'slow') {
      await this.setState({atra: false, veryFast: false, lightning: false});
    } else if (speed === 'atra') {
      await this.setState({atra: true, veryFast: false, lightning: false});
    } else if (speed === 'veryFast') {
      await this.setState({atra: false, veryFast: true, lightning: false});
    } else if (speed === 'lightning') {
      await this.setState({atra: false, veryFast: false, lightning: true});
    }
  
    this.setState({
      maxLengthTime: this.getMaxLengthTime(roundLength, rounds, newRoundPause),
    });
  }

  togglePlayerPerRoomLimit = (type) => {
    const { playerPerRoomLimit } = this.state;

    if (playerPerRoomLimit === type) {
      this.setState({ playerPerRoomLimit: 'none' });
    } else {
      this.setState({ playerPerRoomLimit: type });
    }
  }

  handleClick = (e, index) => {
    e.preventDefault();
    this.setState({
      currentPage: index,
    });
  }

  selectBet = (e) => {
    this.setState({ bet: e.target.value });
  }

  selectTournamentType = (e) => {
    this.setState({ tournamentType: e.target.value });
  }

  sponsorHandleEditPhoto = (value) => {
    this.setState({
      sponsorShowCrop: !value
    })
  }

  sponsorOnCrop = (sponsorPreview) => {
    this.setState({ sponsorPreview });
  }

  prizeHandleEditPhoto = (value) => {
    console.log(value);
    this.setState({ prizeShowCrop: !value });
  }

  prizeOnCrop = (prizePreview) => {
    this.setState({ prizePreview });
  }

  bannerPrizeHandleEditPhoto = (value) => {
    console.log(value);
    this.setState({ bannerPrizeShowCrop: !value });
  }

  bannerPrizeOnCrop = (bannerPrizePreview) => {
    this.setState({ bannerPrizePreview });
  }

  sponsorHandleImageClick = () => {
    this.sponsorHiddenFileInput.current.click();
  };

  prizeHandleImageClick = () => {
    this.prizeHiddenFileInput.current.click();
  };

  bannerPrizeHandleImageClick = () => {
    this.bannerPrizeHiddenFileInput.current.click();
  };

  handleImageChange = (e, imageType) => {
    e.preventDefault();

    try {
      const { showNotification, t } = this.props;
      const typeList = 'image/jpg,image/png,image/jpeg, image/pjp, image/pjpeg, image/jfif';
      const reader = new FileReader();
      const file = e.target.files[0];

      if (!typeList.includes(file.type) || file.type === '') {
        showNotification('Error!', "Unsupported file!", 'danger');
        return e.target.value === '';
      }

      if (file.size / 1024 > 3072) {
        showNotification('Warning', "You can't upload more than 3MB", 'warning');
        return e.target.value === '';
      }

      if (imageType === TOURNAMENT_OPTION_IMAGES.sponsor) {
        reader.onloadend = () => {
          this.setState({
            sponsorPreview: reader.result,
            sponsorUploadFile: file,
          });
        };
      } else if (imageType === TOURNAMENT_OPTION_IMAGES.prize) {
        reader.onloadend = () => {
          this.setState({
            prizePreview: reader.result,
            prizeUploadFile: file,
          });
        };
      } else {
        reader.onloadend = () => {
          this.setState({
            bannerPrizePreview: reader.result,
            bannerPrizeUploadFile: file,
          });
        };
      }

      reader.readAsDataURL(file);
    } catch (err) {
      const { showNotification, t } = this.props;
      showNotification('Error!', err.message, 'danger');

      return e.target.value === '';
    }
  }

  uploadEventFile = (imageType) => {
    const { supportAMessageFileUpload } = this.props;
    const { sponsorUploadFile, prizeUploadFile, bannerPrizeUploadFile } = this.state;


    console.log('uploadEventFile test 111');

    this.setState({ ableToSave: true });
    console.log(sponsorUploadFile, "sponsorImageUrl===")
    if (imageType === TOURNAMENT_OPTION_IMAGES.sponsor) {

      if (sponsorUploadFile !== null) {
        supportAMessageFileUpload(sponsorUploadFile).then((data) => {
          console.log('value@@@@@@@@@@@@@@@@', data);
          this.setState({
            sponsorImageUrl: data.url,
            ableToSave: false,
          });
        }).catch((e) => {
          this.setState({
            sponsorPreview: null,
            ableToSave: false,
          });
        });
      }
    } else if (imageType === TOURNAMENT_OPTION_IMAGES.prize) {
      if (prizeUploadFile !== null) {
        supportAMessageFileUpload(prizeUploadFile).then((data) => {
          console.log('value@@@@@@@@@@@@@@@@', data);
          this.setState({
            prizeImageUrl: data.url,
            ableToSave: false,
          });
        }).catch((e) => {
          this.setState({
            prizePreview: null,
            ableToSave: false,
          });
        });
      }
    } else {
      console.log('test 222');
      if (bannerPrizeUploadFile !== null) {
        supportAMessageFileUpload(bannerPrizeUploadFile).then((data) => {
          console.log('supportAMessageFileUpload res', data.url);
          this.setState({
            bannerPrizeImageUrl: data.url,
            ableToSave: false,
          });
        }).catch((e) => {
          this.setState({
            bannerPrizePreview: null,
            ableToSave: false,
          });
        });
      }
    }
  }

  handlePreviewPhoto = (previewImg, imageType) => {
    console.log("previewImage");
    if (imageType === TOURNAMENT_OPTION_IMAGES.sponsor) {
      this.setState({
        sponsorPreview: previewImg,
      });
    } else if (imageType === TOURNAMENT_OPTION_IMAGES.prize) {
      this.setState({
        prizePreview: previewImg,
      });
    } else {
      this.setState({
        bannerPrizePreview: previewImg,
      });
    }
  }

  handleReSetImage = (imageType) => {
    if (imageType === TOURNAMENT_OPTION_IMAGES.sponsor) {
      this.setState({
        sponsorPreview: '',
        sponsorImageUrl: '',
      });
    } else if (imageType === TOURNAMENT_OPTION_IMAGES.prize) {
      this.setState({
        prizePreview: '',
        prizeImageUrl: '',
      });
    } else {
      this.setState({
        bannerPrizePreview: '',
        bannerPrizeImageUrl: '',
      });
    }
  }

  handleReSetPreviewImage = (imageType) => {
    if (imageType === TOURNAMENT_OPTION_IMAGES.sponsor) {
      this.setState({
        sponsorPreview: null,
      });
    } else if (imageType === TOURNAMENT_OPTION_IMAGES.prize) {
      this.setState({
        prizePreview: null,
      });
    } else {
      this.setState({
        bannerPrizePreview: null,
      });
    }
  }

  toggleBannerPrizeChecked = () => {
    this.setState({bannerPrizeChecked: !this.state.bannerPrizeChecked});
  }

  toggleBannerShowChecked = () => {
    this.setState({bannerShowChecked: !this.state.bannerShowChecked});
  }

  toggleRepetitiveTournamentChecked = () => {
    this.setState({repetitiveTournament: !this.state.repetitiveTournament});
  }

  openChatModalFunc = (uid, name) => {
    this.setState({
      openChatModal: true,
      openChatModalName: name,
      openChatModalUid: uid,
    });
  }

  openChatModalMultipleFunc = () => {
    const { selectedUsers } = this.state;

    this.setState({
        openChatModal: true,
        openChatModalName: 'multiple users',
        openChatModalUid: selectedUsers.length,
        openChatModalMultiple: true,
    });
  }

  replaceTournamentsPlayerResult = (text) => {
    let resultText = text;
    if (text?.includes("room points -") && text?.includes("added points -")) {
      resultText = replace(resultText, "room points -", "room points:");
      resultText = replace(resultText, "added points -", "added points:");
    } else if (text?.includes("room points -")) {
      resultText = replace(resultText, "room points -", "room points:");
    } else if (text?.includes("added points -")) {
      resultText = replace(resultText, "added points -", "added points:");
    }

    return resultText;
  }

  handleMouseEnter = (key) => {
    this.setState({
      popInfoKey: key,
    })
    console.log(key, "mouse enter")
  }

  table = () => {
    const {
      t, allTournaments, offset,
    } = this.props;
    const {
      currentPage,
      pageSize,
      filteredAllTournaments,
      popInfoKey,
    } = this.state;

    const pagesCount = Math.ceil(Object.keys(filteredAllTournaments).length / pageSize);

    return (
      <Fragment>
        {filteredAllTournaments && Object.keys(filteredAllTournaments)
          .reverse()
          .slice(
            currentPage * pageSize,
            (currentPage + 1) * pageSize,
          )
          .map((key, index) => {
            if (!allTournaments[key]) return null;

            return (
              <Fragment key={key}>
                <tr
                  key={key}
                  className={`allTournaments-table-row ${index % 2 === 0 ? ('odd') : ('even')}`}
                >
                  <td className="allTournaments-table-col text-left">
                    {allTournaments[key].name}
                  </td>
                  <td className="allTournaments-table-col" id={`registered-players-info-${key}`} onMouseEnter={() => this.handleMouseEnter(key)} onMouseLeave={() => this.handleMouseEnter('')}>
                    {allTournaments[key].registeredPlayers}
                  </td>
                  <UncontrolledPopover
                    popperClassName="popover"
                    isOpen={popInfoKey === key && allTournaments[key]?.registeredPlayers}
                    placement="bottom"
                    trigger="focus"
                    target={`registered-players-info-${key}`}
                  >
                    <PopoverBody className="popover-body">
                      <div className='d-flex flex-column'>
                        {allTournaments[key]?.registeredPlayers && (
                          <div>{`Joined Players: ${allTournaments[key].registeredPlayers}`}</div>
                        )}
                        {allTournaments[key]?.activePlayers && (
                          <div>{`Active Players: ${allTournaments[key].activePlayers}`}</div>
                        )}
                        {allTournaments[key]?.pausedPlayers && (
                          <div>{`Paused Players: ${allTournaments[key].pausedPlayers}`}</div>
                        )}
                        {allTournaments[key]?.leftPlayers && (
                          <div>{`Left Players: ${allTournaments[key].leftPlayers}`}</div>
                        )}
                      </div>
                    </PopoverBody>
                  </UncontrolledPopover>
                  <td className="allTournaments-table-col">
                    {allTournaments[key].totalBank + (allTournaments[key].bonus ? parseInt(allTournaments[key].bonus, 10) : 0)}
                  </td>
                  <td className="allTournaments-table-col" style={{ width: 50 }}>
                    {allTournaments[key].currentRound}
                  </td>
                  <td className="allTournaments-table-col">
                    {allTournaments[key].devTournament ? 'dev' : 'prod'}
                  </td>
                  <td className="allTournaments-table-col">
                    <Moment format="DD-MM-YYYY HH:mm" locale="lv">
                      {allTournaments[key].startDate + offset}
                    </Moment>
                  </td>
                  <td className="allTournaments-table-col">
                    <Moment format="DD-MM-YYYY HH:mm" locale="lv">
                      {allTournaments[key].startDate - ((allTournaments[key].registerTime || 0) * (1000 * 60)) + offset}
                    </Moment>
                  </td>
                  <td className="allTournaments-table-col">
                    {allTournaments[key].currentState}
                  </td>
                  <td className="allTournaments-table-col">
                    <Button className="allTournaments-table-col-button" color="primary" onClick={() => this.openModal(key)}>
                      Edit
                    </Button>
                  </td>
                  <td className="allTournaments-table-col">
                    <Button className="allTournaments-table-col-button" color="primary" onClick={() => this.openResultsModal(key)}>
                      Results
                    </Button>
                  </td>
                  <td className="allTournaments-table-col">
                    <Button className="allTournaments-table-col-button" color="primary" onClick={() => this.openPlayersModal(key, allTournaments[key].currentState)}>
                      Players
                    </Button>
                  </td>
                  <td className="allTournaments-table-col">
                    {key}
                  </td>
                  <td className="allTournaments-table-col">
                    {allTournaments[key].prizeImg ? 'Yes' : 'No'}
                  </td>
                  <td className="allTournaments-table-col first-capitial">
                    {allTournaments[key].tournamentType || 'Regular'}
                  </td>
                  <td className="allTournaments-table-col">
                    {allTournaments[key].bet}
                  </td>
                  <td className="allTournaments-table-col">
                    {allTournaments[key].entryFee}
                  </td>
                  <td className="allTournaments-table-col">
                    {allTournaments[key].bonus}
                  </td>
                  <td className="allTournaments-table-col">
                    {allTournaments[key].newRoundPause}
                  </td>
                  <td className="allTournaments-table-col">
                    {allTournaments[key].rounds}
                  </td>
                  <td className="allTournaments-table-col" style={{ width: 50 }}>
                    {allTournaments[key].roundLength}
                  </td>
                  <td className="allTournaments-table-col">
                    {allTournaments[key].lightningGame && 'lightning'}
                    {allTournaments[key].veryFastGame && 'very fast'}
                    {allTournaments[key].fastGame && 'fast'}
                    {allTournaments[key].unlimitedGame && 'unlimited'}
                    {!allTournaments[key].unlimitedGame && !allTournaments[key].lightningGame && !allTournaments[key].veryFastGame && !allTournaments[key].fastGame && 'slow'}
                  </td>
                  <td className="allTournaments-table-col">
                    {allTournaments[key].gameType === 'P' && (allTournaments[key].smallGame ? 'PM' : 'P')}
                    {allTournaments[key].gameType === 'G' && (allTournaments[key].smallGame ? 'MG' : 'G')}
                  </td>
                  <td className="allTournaments-table-col" style={{ width: 80 }}>
                    {allTournaments[key].registerTime}
                  </td>
                  {/** dont delete */}
                  {/* <td className="allTournaments-table-col" style={{ width: 60 }}>
                    {allTournaments[key].maxPlayers}
                  </td> */}
                  {allTournaments[key].currentState !== 'closed' ? (
                    <td className="allTournaments-table-col">
                      <Button className="allTournaments-table-col-button" color="danger" onClick={() => this.toggleForceCloseTournament(key)}>
                        Close
                      </Button>
                    </td>
                  ) : (
                    <td className="allTournaments-table-col">
                      <Button className="allTournaments-table-col-button" color="danger" onClick={() => this.toggleDeleteModal(key)}>
                        Delete
                      </Button>
                    </td>
                  )}
                </tr>
              </Fragment>
            );
          })}
        {Object.keys(filteredAllTournaments).length > pageSize && (
          <div className="pagination-wrapper">
            <Pagination aria-label="Page navigation example">
              <PaginationItem disabled={currentPage === 0}>
                <PaginationLink style={{ color: '#000' }} onClick={e => this.handleClick(e, 0)} href="#">
                  {`‹‹‹`}
                </PaginationLink>
              </PaginationItem>

              <PaginationItem disabled={currentPage <= 0}>
                <PaginationLink
                  onClick={e => this.handleClick(e, currentPage - 1)}
                  previous
                  href="#"
                  style={{ color: '#000' }}
                />
              </PaginationItem>

              {[...Array(pagesCount)].map((page, i) => {
                if (i > currentPage - 3 && i < currentPage + 3) {
                  return (
                    <PaginationItem active={i === currentPage} key={page}>
                      <PaginationLink style={{ color: '#000' }} onClick={e => this.handleClick(e, i)} href="#" >
                        {i + 1}
                      </PaginationLink>
                    </PaginationItem>
                  );
                }

                return null;
              })}

              <PaginationItem disabled={currentPage >= pagesCount - 1}>
                <PaginationLink
                  onClick={e => this.handleClick(e, currentPage + 1)}
                  next
                  href="#"
                  style={{ color: '#000' }}
                />
              </PaginationItem>

              <PaginationItem disabled={currentPage >= pagesCount - 1}>
                <PaginationLink onClick={e => this.handleClick(e, pagesCount - 1)} href="#" style={{ color: '#000' }}>
                  {`›››`}
                </PaginationLink>
              </PaginationItem>
            </Pagination>
          </div>
        )}
      </Fragment>
    );
  }

  toggleLeaveReasonModal = (leaveReason) => {
    this.setState({ leaveReasonModal: leaveReason});
  }

  getFilteredTournaments(allTournaments, environment) {
    return Object.fromEntries(
      Object.entries(allTournaments)
        .filter(([_, tournament]) => {
          if (environment === 'all') return true;
          if (environment === 'prod') return !tournament.devTournament;
          if (environment === 'dev') return tournament.devTournament;
          return false; // Fallback: exclude if unknown environment
        })
        .sort(([, a], [, b]) => a.startDate - b.startDate)
    );
  }

  render() {
    const {
      t, tournamentPlayers, tournamentPlayersArr, tournamentResults, tournamentPlayerHistory, bots, showNotification, allTournaments, offset,
    } = this.props;
    const {
      deleteModal,
      forceCloseModal,
      name,
      titleLV,
      titleEN,
      titleRU,
      bet,
      entryFee,
      playerPerRoomLimit,
      bonus,
      //  startTime,
      //  endTime,
      startDate,
      bannerStartDate,
      bannerEndDate,
      //  endDate,
      registerTime,
      registerDateTime,
      maxLengthTime,
      winnerPercent,
      //  minPlayers,
      openModal,
      openAddModal,
      parasta,
      G,
      atra,
      veryFast,
      lightning,
      unlimited,
      pro,
      maza,
      privateTournament,
      devTournament,
      sponsorImg,
      prizeImg,
      password,
      maxPlayers,
      newRoundPause,
      rounds,
      roundLength,
      openPlayersModal,
      playersModalId,
      openResultsModal,
      openResultsRound,
      openPlayerHistoryModal,

      sponsorPreview,
      sponsorImageUrl,
      sponsorShowCrop,

      prizePreview,
      prizeImageUrl,
      prizeShowCrop,

      bannerPrizePreview,
      bannerPrizeImageUrl,
      bannerPrizeShowCrop,

      loading,
      ableToSave,
      playerHistoryId,
      openChatModal,
      openChatModalUid,
      openChatModalName,
      bannerPrizeChecked,
      bannerShowChecked,
      openedPlayerTournament,
      leaveReasonModal,
      environment,

      specialPrizeLV,
      specialPrizeEN,
      specialPrizeRU,

      tournamentType,

      repetitiveTournament,
      multiDates,
      maxMultiDates,

      restrictions,
      levelFrom,
      levelTo,
      pointsFrom,
      pointsTo,
      balanceFrom,
      balanceTo,
      playedGamesFrom,
      playedGamesTo,
      popInfoKey,
      more,
      selectedUsers,
      openChatModalMultiple,
      tournamentsPerDate,
    } = this.state;

    console.log('maxLengthTime', maxLengthTime);

    console.log('bannerPrizeImageUrl', tournamentResults, restrictions, levelFrom, levelTo, balanceFrom);

    const numbersOnly = (e) => {
      if (!((e.key >= '0' && e.key <= '9') || e.key === 'Backspace' || e.key === 'Delete')) { e.preventDefault(); }
    }

    const numbersOnlyWithMinus = (e) => {
      const allowed =
        (e.key >= '0' && e.key <= '9') ||
        e.key === 'Backspace' ||
        e.key === 'Delete' ||
        e.key === '-';

      if (!allowed) {
        e.preventDefault();
      }
    };


    const roundUpToNext30 = (date) => {
      const result = new Date(date);
      result.setSeconds(0);
      result.setMilliseconds(0);
      const minutes = result.getMinutes();
      const rounded = Math.ceil(minutes / 30) * 30;
      result.setMinutes(rounded);
      return result;
    }

    const now = new Date();
    const dayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
    const dayNext30 = roundUpToNext30(now);
    const dayNext30before = roundUpToNext30(new Date(Date.now() - 3 * 60 * 60 * 1000));

    return (
      <Fragment>
        <UncontrolledPopover popperClassName={`popover`} placement="right" trigger="focus" target="admin-help-button-all-tournaments">
          <PopoverBody className="popover-body">
            A list of all created tournament and their details. An admin can create a new one or edit/close an ongoing tournament.
            <br /><br />
            Note: please be careful with editing an active tournament as it can cause problems for the tournament rooms in the backend.
          </PopoverBody>
        </UncontrolledPopover>
        {/* <UncontrolledPopover popperClassName={`popover`} isOpen={popInfoKey && allTournaments[popInfoKey].registeredPlayers} placement="bottom" trigger="focus" target={`registered-players-info-${popInfoKey}`}>
          <PopoverBody className="popover-body">
            <div className='d-flex flex-column'>
              {allTournaments[popInfoKey]?.registeredPlayers && (
                <div>{`Joined Players: ${allTournaments[popInfoKey]?.registeredPlayers?? 0}`}</div>
              )}
              {allTournaments[popInfoKey]?.activePlayers && (
                <div>{`Active Players: ${allTournaments[popInfoKey]?.activePlayers ?? 0}`}</div>
              )}
              {allTournaments[popInfoKey]?.pausedPlayers && (
                <div>{`Paused Players: ${allTournaments[popInfoKey]?.pausedPlayers ?? 0}`}</div>
              )}
              {allTournaments[popInfoKey]?.leftPlayers && (
                <div>{`Left Players: ${allTournaments[popInfoKey]?.leftPlayers ?? 0}`}</div>
              )}
            </div>
          </PopoverBody>
        </UncontrolledPopover> */}
        <div className="admin-page-content">
          <Row>
            <Col md="6">
              <h2>
                Tournaments
                <Button className="admin-help-button" id="admin-help-button-all-tournaments">
                  ?
                </Button>
              </h2>
            </Col>
            <Col md="2">
              <Button onClick={() => this.openAddModal()}>
                Add Tournament
              </Button>
            </Col>
            <Col md="4">
              <Label for="filterSpeed">
                Environment
              </Label>
              <Input type="select" className="game-bet-select" value={environment} onChange={(e) => this.setState({environment: e.target.value})} style={{width: 146, marginBottom: 20}}>
                <option value="all">All</option>
                <option value="prod">Production</option>
                <option value="dev">Development</option>
              </Input>
            </Col>
          </Row>
          <table style={{ width: '100%', fontSize: 12, color: '#fff'/*, tableLayout: 'fixed'*/ }}>
            <colgroup>
              <col span="1" className="" />
            </colgroup>
            <thead>
              <tr>
                <th style={{ textAlign: 'left' }}>
                  Title
                </th>
                <th style={{ textAlign: 'center' }}>
                  Participants
                </th>
                <th style={{ textAlign: 'center' }}>
                  Total Bank
                </th>
                <th style={{ textAlign: 'center', width: 50}}>
                  Current Round
                </th>
                <th style={{ textAlign: 'center'}}>
                  Environment
                </th>
                <th style={{ textAlign: 'center' }}>
                  Start
                </th>
                <th style={{ textAlign: 'center' }}>
                  Registration
                </th>
                <th style={{ textAlign: 'center' }}>
                  Status
                </th>
                <th style={{ textAlign: 'center' }}>
                  Edit
                </th>
                <th style={{ textAlign: 'center' }}>
                  Results
                </th>
                <th style={{ textAlign: 'center' }}>
                  Players
                </th>
                <th style={{ textAlign: 'center' }}>
                  Id
                </th>
                <th style={{ textAlign: 'center' }}>
                  Prize
                </th>
                <th style={{ textAlign: 'center' }}>
                  Tournament Type
                </th>
                <th style={{ textAlign: 'center' }}>
                  Bet
                </th>
                <th style={{ textAlign: 'center' }}>
                  Fee
                </th>
                <th style={{ textAlign: 'center' }}>
                  Bonus
                </th>
                <th style={{ textAlign: 'center' }}>
                  Pause
                </th>
                <th style={{ textAlign: 'center' }}>
                  Rounds
                </th>
                <th style={{ textAlign: 'center', wdith: 50}}>
                  Round length
                </th>
                <th style={{ textAlign: 'center' }}>
                  Speed
                </th>
                <th style={{ textAlign: 'center' }}>
                  Type
                </th>
                <th style={{ textAlign: 'center', width: 80 }}>
                  Registration time
                </th>
                {/** dont delete */}
                {/* <th style={{ textAlign: 'center', width: 60}}>
                  Max players
                </th> */}

                <th style={{ textAlign: 'center' }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {this.table()}
            </tbody>
          </table>
        </div>

        {/* Delete tournament modal */}
        <Modal container={'div > div'} isOpen={deleteModal} toggle={() => this.toggleDeleteModal('')} className="notification">
          <ModalHeader
            toggle={() => this.toggleDeleteModal('')}
            className="notification-header"
            close={
              <Media src={closeImg} className="notification-header-close" alt="X" onClick={() => this.toggleDeleteModal('')} />
            }
          />
          <ModalBody className="notification-body">
            Do you really want to delete the tournament?
          </ModalBody>
          <ModalFooter className="notification-footer">
            <Button className="btn notification-footer-button" onClick={this.deleteTournament}>
              Yes
            </Button>
            <Button type="button" className="btn notification-footer-button" onClick={() => this.toggleDeleteModal('')}>
              No
            </Button>
          </ModalFooter>
        </Modal>

        {/* Force close modal */}
        <Modal container={'div > div'} isOpen={forceCloseModal} toggle={() => this.toggleForceCloseTournament('')} className="notification">
          <ModalHeader
            toggle={() => this.toggleForceCloseTournament('')}
            className="notification-header"
            close={
              <Media src={closeImg} className="notification-header-close" alt="X" onClick={() => this.toggleForceCloseTournament('')} />
            }
          />
          <ModalBody className="notification-body">
            Do you really want to close an active tournament?
          </ModalBody>
          <ModalFooter className="notification-footer">
            <Button className="btn notification-footer-button" onClick={this.forceCloseTournament}>
              Yes
            </Button>
            <Button type="button" className="btn notification-footer-button" onClick={() => this.toggleForceCloseTournament('')}>
              No
            </Button>
          </ModalFooter>
        </Modal>

        {/* Edit tournament modal */}
        <Modal container={'div > div'} className="admin-modal" isOpen={openModal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>
            Edit
          </ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label for="titleLV">
                  Title (LV)
                </Label>
                <Input
                  type="text"
                  name="titleLV"
                  id="titleLV"
                  value={titleLV}
                  onChange={this.handleChange}
                  maxLength={100}
                />
              </FormGroup>
              <FormGroup>
                <Label for="titleEN">
                  Title (EN)
                </Label>
                <Input
                  type="text"
                  name="titleEN"
                  id="titleEN"
                  value={titleEN}
                  onChange={this.handleChange}
                  maxLength={100}
                />
              </FormGroup>
              <FormGroup>
                <Label for="titleRU">
                  Title (RU)
                </Label>
                <Input
                  type="text"
                  name="titleRU"
                  id="titleRU"
                  value={titleRU}
                  onChange={this.handleChange}
                  maxLength={100}
                />
              </FormGroup>
              <FormGroup>
                <Label for="bet">
                  Tournament Type
                </Label>
                <Input type="select" className="game-bet-select" value={tournamentType} onChange={this.selectTournamentType}>
                  {/* <option>1:1</option>
                  <option>1:5</option> */}
                  <option value="regular">Regular</option>
                  <option value="bronze" >Bronze</option>
                  <option value="silver">Silver</option>
                  <option value="gold">Gold</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="bet">
                  Bet
                </Label>
                <Input type="select" className="game-bet-select" value={bet} onChange={this.selectBet}>
                  {/* <option>1:1</option>
                  <option>1:5</option> */}
                  <option>1:10</option>
                  <option>1:25</option>
                  <option>1:50</option>
                  <option>1:100</option>
                  <option>1:250</option>
                  <option>1:500</option>
                  <option>1:1000</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="entryFee">
                  Entry Fee
                </Label>
                <Input
                  type="number"
                  name="entryFee"
                  id="entryFee"
                  value={entryFee}
                  onChange={(e) => {
                    let raw = e.target.value;

                    if (raw.length > 7) {
                      raw = raw.slice(0, 7);
                    }

                    if (raw === '') {
                      this.setState({ entryFee: '' });
                      return;
                    }

                    const num = Number(raw);
                    const value = Math.max(1, num);
                    this.setState({ entryFee: value });
                  }}
                  onBlur={() => {
                    // const { entryFee } = this.state;
                    if (entryFee === '') {
                      this.setState({ entryFee: 1 });
                    }
                  }}
                  onKeyDown={numbersOnly}
                  onWheel={(e) => e.target.blur()}
                />
              </FormGroup>
              <FormGroup>
                <Label for="bonus">
                  Bonus
                </Label>
                <Input
                  type="number"
                  name="bonus"
                  id="bonus"
                  value={bonus}
                  onChange={(e) => {
                    let raw = e.target.value;

                    if (raw.length > 7) {
                      raw = raw.slice(0, 7);
                    }

                    if (raw === '') {
                      this.setState({ bonus: '' });
                      return;
                    }

                    const num = Number(raw);
                    const value = Math.max(0, num);
                    this.setState({ bonus: value });
                  }}
                  onBlur={() => {
                    // const { bonus } = this.state;
                    if (bonus === '') {
                      this.setState({ bonus: 0 });
                    }
                  }}
                  onKeyDown={numbersOnly}
                  onWheel={(e) => e.target.blur()}
                />
              </FormGroup>
              {/* <FormGroup>
                <Label for="newRoundPause">
                  Pause between rounds (min: 1 minute, max: 10 minutes)
                </Label>
                <Input
                  type="number"
                  name="newRoundPause"
                  id="newRoundPause"
                  value={newRoundPause}
                  onChange={this.handleChange}
                  onKeyDown={numbersOnly}
                  onWheel={(e) => e.target.blur()}
                />
              </FormGroup> */}
              <FormGroup>
                <Label for="filterSpeed">
                  Pause between rounds (min: 1 minute, max: 10 minutes)
                </Label>
                <Input type="select" className="game-bet-select" value={newRoundPause} onChange={(e) => this.setState({newRoundPause: e.target.value})/*this.selectFilterByTimeBetween*/}>
                  {Array.from({ length: 10 }, (_, index) => (
                    <option key={index + 1} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="rounds">
                  Rounds per Tournament (min: 4, max: 10)
                </Label>
                <Input
                  type="number"
                  name="rounds"
                  id="rounds"
                  value={rounds}
                  onChange={(e) => {
                    let raw = e.target.value;

                    if (raw.length > 2) {
                      raw = raw.slice(0, 2);
                    }

                    if (raw === '') {
                      this.setState({ rounds: '' });
                      return;
                    }

                    const num = Number(raw);
                    const value = Math.max(1, num);
                    this.setState({ rounds: value });
                  }}
                  onBlur={() => {
                    if (rounds === '') {
                      this.setState({ rounds: 1 });
                    }
                  }}
                  onKeyDown={numbersOnly}
                  onWheel={(e) => e.target.blur()}
                />
              </FormGroup>
              <FormGroup>
                <Label for="roundLength">
                  Round Length (12, 24 or 36 games)
                </Label>
                <Input
                  type="number"
                  name="roundLength"
                  id="roundLength"
                  value={roundLength}
                  onChange={(e) => {
                    let raw = e.target.value;

                    if (raw.length > 2) {
                      raw = raw.slice(0, 2);
                    }

                    if (raw === '') {
                      this.setState({ roundLength: '' });
                      return;
                    }

                    const num = Number(raw);
                    const value = Math.max(1, num);
                    this.setState({ roundLength: value });
                  }}
                  onBlur={() => {
                    if (roundLength === '') {
                      this.setState({ roundLength: 1 });
                    }
                  }}
                  onKeyDown={numbersOnly}
                  onWheel={(e) => e.target.blur()}
                />
              </FormGroup>
              <Row>
                <Col sm="3">
                  <Label className="game-type-input" style={{ marginLeft: 20 }}>
                    <Input type="radio" onClick={() => this.togglePlayerPerRoomLimit(3)} checked={playerPerRoomLimit === 3} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Only 3 player rooms
                    </div>
                  </Label>
                </Col>
                <Col sm="3">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="radio" onClick={() => this.togglePlayerPerRoomLimit('none')} checked={playerPerRoomLimit === 'none'} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      3 and 4 player rooms
                    </div>
                  </Label>
                </Col>
                <Col sm="3">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="radio" onClick={() => this.togglePlayerPerRoomLimit(4)} checked={playerPerRoomLimit === 4} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Only 4 player rooms
                    </div>
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col sm="6">
                  <Label className="game-type-input" style={{ marginLeft: 20 }}>
                    <Input type="radio" onClick={() => this.toggleGameType('parasta')} checked={parasta} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      P
                    </div>
                  </Label>
                </Col>
                <Col sm="6">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="radio" onClick={() => this.toggleGameType('G')} checked={G} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      G
                    </div>
                  </Label>
                </Col>
                <Col sm="3">
                  <Label className="game-type-input" style={{ marginLeft: 20 }}>
                    <Input type="radio" onClick={() => this.toggleGameSpeed('slow')} checked={!atra && !veryFast && !lightning} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Slow (25&nbsp;seconds)
                    </div>
                  </Label>
                </Col>
                <Col sm="3">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="radio" onClick={() => this.toggleGameSpeed('atra')} checked={atra} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Fast (15&nbsp;seconds)
                    </div>
                  </Label>
                </Col>
                <Col sm="3">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="radio" onClick={() => this.toggleGameSpeed('veryFast')} checked={veryFast} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Very Fast (10&nbsp;seconds)
                    </div>
                  </Label>
                </Col>
                <Col sm="3">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="radio" onClick={() => this.toggleGameSpeed('lightning')} checked={lightning} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Lightning (5&nbsp;seconds)
                    </div>
                  </Label>
                </Col>
                {/* <Col sm="6">
                  <Label className="game-type-input" style={{ marginLeft: 20 }}>
                    <Input type="checkbox" onClick={() => this.toggleGameType('atra')} checked={atra} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Fast
                    </div>
                  </Label>
                </Col>
                <Col sm="6">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="checkbox" onClick={() => this.toggleGameType('lightning')} checked={lightning} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Lightning
                    </div>
                  </Label>
                </Col> */}

                <Col sm="6">
                  <Label className="game-type-input" style={{ marginLeft: 20/*, pointerEvents: 'none', opacity: '0.5'*/ }}>
                    <Input type="checkbox" onClick={() => this.toggleGameType('pro')} checked={pro} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Pro
                    </div>
                  </Label>
                </Col>
                <Col sm="6">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="checkbox" onClick={() => this.toggleGameType('maza')} checked={maza} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Small
                    </div>
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col sm="6">
                  <Label className="game-type-input" style={{ marginLeft: 20 }}>
                    <Input type="checkbox" onClick={() => this.toggleGameType('privateTournament')} checked={privateTournament} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Private
                    </div>
                  </Label>
                </Col>

                <Col sm="6">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="checkbox" onClick={() => this.toggleGameType('devTournament')} checked={devTournament} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      DEV ONLY
                    </div>
                  </Label>
                </Col>

                {privateTournament ? (
                  <Col sm="6" style={{marginLeft: 20 }}>
                    <Label for="password">
                      Password
                    </Label>
                    <Input
                      type="text"
                      name="password"
                      id="password"
                      value={password}
                      onChange={this.handleChange}
                      onKeyDown={numbersOnly}
                    />
                  </Col>
                ) : (null)}


              </Row>

              <FormGroup style={{ marginLeft: '20px', marginTop: 20 }}>
                <Input type="checkbox" name="restrictions" checked={restrictions} value={restrictions} onChange={this.handleChange} readOnly/>
                <span className="checkmark" />
                <div className="game-type-text">
                  Restrictions
                  <div className="admin-arrow-wrapper admin-arrow-wrapper-small ml-2">
                    <div className={restrictions ? 'admin-arrow-down' : 'admin-arrow-up'} />
                  </div>
                </div>
              </FormGroup>
              <FormGroup style={{display: restrictions ? 'block' : 'none'}}>
                <Col sm="12">Level</Col>
                <FormGroup>
                  <Row>
                    <Col sm="6">
                      <Label>From</Label>
                      <Input type="text" name="levelFrom" value={levelFrom} disabled={!restrictions} onChange={this.handleChange} onKeyDown={numbersOnly} />
                    </Col>
                    <Col sm="6">
                      <Label>To</Label>
                      <Input type="text" name="levelTo" value={levelTo} disabled={!restrictions} onChange={this.handleChange} onKeyDown={numbersOnly} />
                    </Col>
                  </Row>
                </FormGroup>
              </FormGroup>
              <FormGroup style={{display: restrictions ? 'block' : 'none'}}>
                <Col sm="12">Points</Col>
                <FormGroup>
                  <Row>
                    <Col sm="6">
                      <Label>From</Label>
                      <Input type="text" name="pointsFrom" value={pointsFrom} disabled={!restrictions} onChange={this.handleChange} onKeyDown={numbersOnlyWithMinus} />
                    </Col>
                    <Col sm="6">
                      <Label>To</Label>
                      <Input type="text" name="pointsTo" value={pointsTo} disabled={!restrictions} onChange={this.handleChange} onKeyDown={numbersOnlyWithMinus} />
                    </Col>
                  </Row>
                </FormGroup>
              </FormGroup>
              <FormGroup style={{display: restrictions ? 'block' : 'none'}}>
                <Col sm="12">Balance</Col>
                <FormGroup>
                  <Row>
                    <Col sm="6">
                      <Label>From</Label>
                      <Input type="text" name="balanceFrom" value={balanceFrom} disabled={!restrictions} onChange={this.handleChange} onKeyDown={numbersOnlyWithMinus} />
                    </Col>
                    <Col sm="6">
                      <Label>To</Label>
                      <Input type="text" name="balanceTo" value={balanceTo} disabled={!restrictions} onChange={this.handleChange} onKeyDown={numbersOnlyWithMinus} />
                    </Col>
                  </Row>
                </FormGroup>
              </FormGroup>
              <FormGroup style={{display: restrictions ? 'block' : 'none'}}>
                <Col sm="12">Played games</Col>
                <FormGroup>
                  <Row>
                    <Col sm="6">
                      <Label>From</Label>
                      <Input type="text" name="playedGamesFrom" value={playedGamesFrom} disabled={!restrictions} onChange={this.handleChange} onKeyDown={numbersOnly} />
                    </Col>
                    <Col sm="6">
                      <Label>To</Label>
                      <Input type="text" name="playedGamesTo" value={playedGamesTo} disabled={!restrictions} onChange={this.handleChange} onKeyDown={numbersOnly} />
                    </Col>
                  </Row>
                </FormGroup>
              </FormGroup>

              <FormGroup>
                <Label for="startDate">
                  Start Time
                </Label>
                <Row>
                  <Col md="12">
                    <DateTimePicker
                    //  time={false}
                      format="DD.MM.YYYY HH:mm"
                      culture="en"
                      onChange={this.ChangeStartDate}
                      value={startDate}
                      defaultValue={new Date()}
                      // min={new Date()}
                      step={30}
                      // currentDate={roundUpToNext30(new Date())}
                      // min={roundUpToNext30(new Date())}

                      // currentDate={repetitiveTournament ? dayStart : dayNext30}
                      min={repetitiveTournament ? dayStart : dayNext30}
                    />
                  </Col>
                  {/*  <Col md="6">
                    <DateTimePicker
                      date={false}
                      timeFormat="HH:mm"
                      culture="en"
                      onChange={this.ChangeStartTime}
                      value={startTime}
                      defaultValue={new Date()}
                    />
                  </Col>  */}
                </Row>
              </FormGroup>
              {/* <FormGroup>
                <Label for="registerTime">
                  Registration time (min)
                </Label>
                <Input
                  type="number"
                  name="registerTime"
                  id="registerTime"
                  value={registerTime}
                  onChange={this.handleChange}
                  onKeyDown={numbersOnly}
                  onWheel={(e) => e.target.blur()}
                />
              </FormGroup> */}
              <FormGroup>
                <Label for="registerTime">
                  Registration time
                </Label>
                <Row>
                  <Col md="12">
                    <DateTimePicker
                      format="DD.MM.YYYY HH:mm"
                      culture="en"
                      onChange={this.changeRegisterDateTime}
                      value={registerDateTime}
                      defaultValue={new Date()}
                      // min={new Date()}
                      step={30}
                      // currentDate={roundUpToNext30(new Date())}
                      // min={roundUpToNext30(new Date())}

                      // currentDate={repetitiveTournament ? dayStart : dayNext30}
                      min={repetitiveTournament ? dayStart : dayNext30}
                    />
                    {maxLengthTime ? (
                      <div>
                        Maximum duration: {formatMinutes(maxLengthTime, 'en')}
                      </div>
                    ) : null}
                  </Col>
                </Row>
              </FormGroup>

              <FormGroup>
                <Label for="winnerPercent">
                  Winning Percent
                </Label>
                <Input
                  type="number"
                  name="winnerPercent"
                  id="winnerPercent"
                  value={winnerPercent}
                  onChange={(e) => {
                    const raw = e.target.value;

                    if (raw === '') {
                      this.setState({ winnerPercent: '' });
                      return;
                    }

                    if (raw.length === 3 && raw.substring(0, 2) !== '10') {
                      return;
                    }

                    const value = Math.min(100, Math.max(1, Number(raw)));
                    this.setState({ winnerPercent: value });
                  }}
                  onBlur={() => {
                    if (winnerPercent === '') {
                      this.setState({ winnerPercent: 1 });
                    }
                  }}
                  onKeyDown={numbersOnly}
                  onWheel={(e) => e.target.blur()}
                />
              </FormGroup>

              <FormGroup style={{ marginLeft: '20px' }}>
                <Input type="checkbox" name="more" checked={more} value={more} onChange={this.handleChange} readOnly/>
                <span className="checkmark" />
                <div className="game-type-text">
                  More

                  <div className="admin-arrow-wrapper admin-arrow-wrapper-small ml-2">
                    <div className={more ? 'admin-arrow-down' : 'admin-arrow-up'} />
                  </div>
                </div>
              </FormGroup>

              {more && (
                <Fragment>
                  <FormGroup className="tournaments-image-option">
                    <FileUploadImage
                      preview={sponsorPreview}
                      imageUrl={sponsorImageUrl}
                      showCrop={sponsorShowCrop}
                      hiddenFileInput={this.sponsorHiddenFileInput}
                      handleImageClick={this.sponsorHandleImageClick}
                      handleImageChange={this.handleImageChange}
                      handleEditPhoto={this.sponsorHandleEditPhoto}
                      uploadEventFile={this.uploadEventFile}
                      imageType={TOURNAMENT_OPTION_IMAGES.sponsor}
                      loading={loading}
                      handlePreviewPhoto={this.handlePreviewPhoto}
                      handleReSetImage={this.handleReSetImage}
                      handleReSetPreviewImage={this.handleReSetPreviewImage}
                    />
                    <FileUploadImage
                      preview={prizePreview}
                      imageUrl={prizeImageUrl}
                      showCrop={prizeShowCrop}
                      hiddenFileInput={this.prizeHiddenFileInput}
                      handleImageClick={this.prizeHandleImageClick}
                      handleImageChange={this.handleImageChange}
                      handleEditPhoto={this.prizeHandleEditPhoto}
                      uploadEventFile={this.uploadEventFile}
                      imageType={TOURNAMENT_OPTION_IMAGES.prize}
                      loading={loading}
                      handlePreviewPhoto={this.handlePreviewPhoto}
                      handleReSetImage={this.handleReSetImage}
                      handleReSetPreviewImage={this.handleReSetPreviewImage}
                    />
                  </FormGroup>

                  <FormGroup className="tournaments-image-option">
                    <div style={{ width: '50%', display: 'flex', alignItems: 'start', justifyContent: 'center' }}>
                      <Label>
                        <Input type="checkbox" onClick={() => this.toggleBannerPrizeChecked()} checked={bannerPrizeChecked} readOnly />
                        <span className="checkmark" />
                        <div className="game-type-text">
                          Prize
                        </div>
                      </Label>
                    </div>
                    <FileUploadImage
                      preview={bannerPrizePreview}
                      imageUrl={bannerPrizeImageUrl}
                      showCrop={bannerPrizeShowCrop}
                      hiddenFileInput={this.bannerPrizeHiddenFileInput}
                      handleImageClick={this.bannerPrizeHandleImageClick}
                      handleImageChange={this.handleImageChange}
                      handleEditPhoto={this.bannerPrizeHandleEditPhoto}
                      uploadEventFile={this.uploadEventFile}
                      imageType={TOURNAMENT_OPTION_IMAGES.banner}
                      loading={loading}
                      handlePreviewPhoto={this.handlePreviewPhoto}
                      handleReSetImage={this.handleReSetImage}
                      handleReSetPreviewImage={this.handleReSetPreviewImage}
                      disabled={!bannerPrizeChecked}
                    />
                  </FormGroup>

                  <div style={bannerPrizeChecked ? {} : { opacity: '0.5', pointerEvents: 'none' }}>
                    <FormGroup>
                      <Label for="specialPrizeLV">
                        Special Prize (LV)
                      </Label>
                      <Input
                        type="text"
                        name="specialPrizeLV"
                        id="specialPrizeLV"
                        value={specialPrizeLV}
                        onChange={this.handleChange}
                        maxLength={100}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="specialPrizeEN">
                        Special Prize (EN)
                      </Label>
                      <Input
                        type="text"
                        name="specialPrizeEN"
                        id="specialPrizeEN"
                        value={specialPrizeEN}
                        onChange={this.handleChange}
                        maxLength={100}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="specialPrizeRU">
                        Special Prize (RU)
                      </Label>
                      <Input
                        type="text"
                        name="specialPrizeRU"
                        id="specialPrizeRU"
                        value={specialPrizeRU}
                        onChange={this.handleChange}
                        maxLength={100}
                      />
                    </FormGroup>
                  </div>

                  <FormGroup>
                    <Label for="maxPlayers">
                      Max Number of Players per Tournament
                    </Label>
                    <Input
                      type="text"
                      name="maxPlayers"
                      id="maxPlayers"
                      value={maxPlayers}
                      onChange={(e) => {
                        let value = e.target.value.replace(/\D/g, "").slice(0, 5);
                        this.setState({ maxPlayers: value });
                      }}
                      onKeyDown={numbersOnly}
                      onWheel={(e) => e.target.blur()}
                    />
                  </FormGroup>
                </Fragment>
              )}

              {/* <FormGroup>
                <Label style={{marginRight: 20}}>
                  <Input type="checkbox" onClick={() => this.toggleGameType('G')} checked={G} readOnly />
                  <span className="checkmark" />
                  <div className="game-type-text">
                    Show Banner
                  </div>
                </Label>
              </FormGroup> */}

              <FormGroup>
                <Label style={{ marginLeft: 20, display: 'inline-block' }}>
                  <Input type="checkbox" onClick={() => this.toggleBannerShowChecked()} checked={bannerShowChecked} readOnly />
                  <span className="checkmark" />
                  <div className="game-type-text">
                    Show banner
                  </div>
                </Label>
                <br />

                <Label for="startDate">
                  Banner Start Time
                </Label>
                <Row>
                  <Col md="12" style={{opacity: bannerShowChecked ? 1 : 0.5}}>
                    <DateTimePicker
                      format="DD.MM.YYYY HH:mm"
                      culture="en"
                      onChange={this.ChangeBannerStartDate}
                      value={bannerStartDate}
                      defaultValue={new Date(Date.now() - 3 * 60 * 60 * 1000)}
                      // min={new Date()}
                      disabled={!bannerShowChecked}

                      step={30}
                      // currentDate={roundUpToNext30(new Date(Date.now() - 3 * 60 * 60 * 1000))}
                      // min={roundUpToNext30(new Date(Date.now() - 3 * 60 * 60 * 1000))}

                      // currentDate={repetitiveTournament ? dayStart : dayNext30before}
                      min={repetitiveTournament ? dayStart : dayNext30before}
                    />
                  </Col>
                </Row>
                <Label for="startDate">
                  Banner End Time
                </Label>
                <Row>
                  <Col md="12" style={{opacity: 0.5}}>
                    <DateTimePicker
                      format="DD.MM.YYYY HH:mm"
                      culture="en"
                      onChange={this.ChangeBannerEndDate}
                      value={bannerEndDate}
                      defaultValue={new Date()}
                      min={new Date()}
                      disabled={true}
                    />
                  </Col>
                </Row>
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            {
              ableToSave ? (
                <Button color="primary" onClick={this.editTournament} disabled>Save</Button>
              ) : (
                <Button color="primary" onClick={this.editTournament}>Save</Button>
              )
            }
            {' '}
            <Button color="secondary" onClick={this.toggle}>Close</Button>
          </ModalFooter>
        </Modal>

        {/* Add tournament modal */}
        <Modal container={'div > div'} className="admin-modal" isOpen={openAddModal} toggle={this.toggleAdd}>
          <ModalHeader toggle={this.toggleAdd}>
            Add Tournament
          </ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label for="titleLV">
                  Title (LV)
                </Label>
                <Input
                  type="text"
                  name="titleLV"
                  id="titleLV"
                  value={titleLV}
                  onChange={this.handleChange}
                  maxLength={100}
                />
              </FormGroup>
              <FormGroup>
                <Label for="titleEN">
                  Title (EN)
                </Label>
                <Input
                  type="text"
                  name="titleEN"
                  id="titleEN"
                  value={titleEN}
                  onChange={this.handleChange}
                  maxLength={100}
                />
              </FormGroup>
              <FormGroup>
                <Label for="titleRU">
                  Title (RU)
                </Label>
                <Input
                  type="text"
                  name="titleRU"
                  id="titleRU"
                  value={titleRU}
                  onChange={this.handleChange}
                  maxLength={100}
                />
              </FormGroup>
              <FormGroup>
                <Label for="bet">
                  Tournament Type
                </Label>
                <Input type="select" className="game-bet-select" value={tournamentType} onChange={this.selectTournamentType}>
                  {/* <option>1:1</option>
                  <option>1:5</option> */}
                  <option value="regular">Regular</option>
                  <option value="bronze" >Bronze</option>
                  <option value="silver">Silver</option>
                  <option value="gold">Gold</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="bet">
                  Bet
                </Label>
                <Input type="select" className="game-bet-select" value={bet} onChange={this.selectBet}>
                  {/* <option>1:1</option>
                  <option>1:5</option> */}
                  <option>1:10</option>
                  <option>1:25</option>
                  <option>1:50</option>
                  <option>1:100</option>
                  <option>1:250</option>
                  <option>1:500</option>
                  <option>1:1000</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="entryFee">
                  Entry Fee
                </Label>
                <Input
                  type="number"
                  name="entryFee"
                  id="entryFee"
                  value={entryFee}
                  onChange={(e) => {
                    let raw = e.target.value;

                    if (raw.length > 7) {
                      raw = raw.slice(0, 7);
                    }

                    if (raw === '') {
                      this.setState({ entryFee: '' });
                      return;
                    }

                    const num = Number(raw);
                    const value = Math.max(1, num);
                    this.setState({ entryFee: value });
                  }}
                  onBlur={() => {
                    // const { entryFee } = this.state;
                    if (entryFee === '') {
                      this.setState({ entryFee: 1 });
                    }
                  }}
                  onKeyDown={numbersOnly}
                  onWheel={(e) => e.target.blur()}
                />
              </FormGroup>
              <FormGroup>
                <Label for="bonus">
                  Bonus
                </Label>
                <Input
                  type="number"
                  name="bonus"
                  id="bonus"
                  value={bonus}
                  onChange={(e) => {
                    let raw = e.target.value;

                    if (raw.length > 7) {
                      raw = raw.slice(0, 7);
                    }

                    if (raw === '') {
                      this.setState({ bonus: '' });
                      return;
                    }

                    const num = Number(raw);
                    const value = Math.max(0, num);
                    this.setState({ bonus: value });
                  }}
                  onBlur={() => {
                    // const { bonus } = this.state;
                    if (bonus === '') {
                      this.setState({ bonus: 0 });
                    }
                  }}

                  onKeyDown={numbersOnly}
                  onWheel={(e) => e.target.blur()}
                />
              </FormGroup>
              {/* <FormGroup>
                <Label for="newRoundPause">
                  Pause between rounds (min: 1 minute, max: 10 minutes)
                </Label>
                <Input
                  type="number"
                  name="newRoundPause"
                  id="newRoundPause"
                  value={newRoundPause}
                  onChange={this.handleChange}
                  onKeyDown={numbersOnly}
                  onWheel={(e) => e.target.blur()}
                />
              </FormGroup> */}
              <FormGroup>
                <Label for="filterSpeed">
                  Pause between rounds (min: 1 minute, max: 10 minutes)
                </Label>
                <Input type="select" className="game-bet-select" value={newRoundPause} onChange={(e) => this.setState({newRoundPause: e.target.value})/*this.selectFilterByTimeBetween*/}>
                  {Array.from({ length: 10 }, (_, index) => (
                    <option key={index + 1} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="rounds">
                  Rounds per Tournament (min: 4, max: 10)
                </Label>
                <Input
                  type="number"
                  name="rounds"
                  id="rounds"
                  value={rounds}
                  onChange={(e) => {
                    let raw = e.target.value;

                    if (raw.length > 2) {
                      raw = raw.slice(0, 2);
                    }

                    if (raw === '') {
                      this.setState({ rounds: '' });
                      return;
                    }

                    const num = Number(raw);
                    const value = Math.max(1, num);
                    this.setState({ rounds: value });
                  }}
                  onBlur={() => {
                    if (rounds === '') {
                      this.setState({ rounds: 1 });
                    }
                  }}
                  onKeyDown={numbersOnly}
                  onWheel={(e) => e.target.blur()}
                />
              </FormGroup>
              <FormGroup>
                <Label for="roundLength">
                  Round Length (12, 24 or 36 games)
                </Label>
                <Input
                  type="number"
                  name="roundLength"
                  id="roundLength"
                  value={roundLength}
                  onChange={(e) => {
                    let raw = e.target.value;

                    if (raw.length > 2) {
                      raw = raw.slice(0, 2);
                    }

                    if (raw === '') {
                      this.setState({ roundLength: '' });
                      return;
                    }

                    const num = Number(raw);
                    const value = Math.max(1, num);
                    this.setState({ roundLength: value });
                  }}
                  onBlur={() => {
                    if (roundLength === '') {
                      this.setState({ roundLength: 1 });
                    }
                  }}
                  onKeyDown={numbersOnly}
                  onWheel={(e) => e.target.blur()}
                />
              </FormGroup>
              <Row>
                <Col sm="3">
                  <Label className="game-type-input" style={{ marginLeft: 20 }}>
                    <Input type="radio" onClick={() => this.togglePlayerPerRoomLimit(3)} checked={playerPerRoomLimit === 3} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Only 3 player rooms
                    </div>
                  </Label>
                </Col>
                <Col sm="3">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="radio" onClick={() => this.togglePlayerPerRoomLimit('none')} checked={playerPerRoomLimit === 'none'} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      3 and 4 player rooms
                    </div>
                  </Label>
                </Col>
                <Col sm="3">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="radio" onClick={() => this.togglePlayerPerRoomLimit(4)} checked={playerPerRoomLimit === 4} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Only 4 player rooms
                    </div>
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col sm="6">
                  <Label className="game-type-input" style={{ marginLeft: 20 }}>
                    <Input type="radio" onClick={() => this.toggleGameType('parasta')} checked={parasta} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      P
                    </div>
                  </Label>
                </Col>
                <Col sm="6">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="radio" onClick={() => this.toggleGameType('G')} checked={G} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      G
                    </div>
                  </Label>
                </Col>

                <Col sm="3">
                  <Label className="game-type-input" style={{ marginLeft: 20 }}>
                    <Input type="radio" onClick={() => this.toggleGameSpeed('slow')} checked={!atra && !veryFast && !lightning} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Slow (25&nbsp;seconds)
                    </div>
                  </Label>
                </Col>
                <Col sm="3">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="radio" onClick={() => this.toggleGameSpeed('atra')} checked={atra} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Fast (15&nbsp;seconds)
                    </div>
                  </Label>
                </Col>
                <Col sm="3">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="radio" onClick={() => this.toggleGameSpeed('veryFast')} checked={veryFast} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Very Fast (10&nbsp;seconds)
                    </div>
                  </Label>
                </Col>
                <Col sm="3">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="radio" onClick={() => this.toggleGameSpeed('lightning')} checked={lightning} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Lightning (5&nbsp;seconds)
                    </div>
                  </Label>
                </Col>

                {/* <Col sm="6">
                  <Label className="game-type-input" style={{ marginLeft: 20 }}>
                    <Input type="checkbox" onClick={() => this.toggleGameType('atra')} checked={atra} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Fast
                    </div>
                  </Label>
                </Col> */}
                {/* <Col sm="6">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="checkbox" onClick={() => this.toggleGameType('lightning')} checked={lightning} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Lightning
                    </div>
                  </Label>
                </Col> */}
                <Col sm="6">
                  <Label className="game-type-input" style={{ marginLeft: 20/*, pointerEvents: 'none', opacity: '0.5'*/ }}>
                    <Input type="checkbox" onClick={() => this.toggleGameType('pro')} checked={pro} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Pro
                    </div>
                  </Label>
                </Col>
                <Col sm="6">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="checkbox" onClick={() => this.toggleGameType('maza')} checked={maza} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Small
                    </div>
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col sm="6">
                  <Label className="game-type-input" style={{ marginLeft: 20 }}>
                    <Input type="checkbox" onClick={() => this.toggleGameType('privateTournament')} checked={privateTournament} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      Private
                    </div>
                  </Label>
                </Col>

                <Col sm="6">
                  <Label className="game-type-input" style={{ marginLeft: 10 }}>
                    <Input type="checkbox" onClick={() => this.toggleGameType('devTournament')} checked={devTournament} readOnly />
                    <span className="checkmark" />
                    <div className="game-type-text">
                      DEV ONLY
                    </div>
                  </Label>
                </Col>

                {privateTournament ? (
                  <Col sm="6" style={{marginLeft: 20 }}>
                    <Label for="password">
                      Password
                    </Label>
                    <Input
                      type="text"
                      name="password"
                      id="password"
                      value={password}
                      onChange={this.handleChange}
                      onKeyDown={numbersOnly}
                    />
                  </Col>
                ) : (null)}
              </Row>

              <FormGroup style={{ marginLeft: '20px', marginTop: 20 }}>
                <Input type="checkbox" name="restrictions" value={restrictions} onChange={this.handleChange} />
                <span className="checkmark" />
                <div className="game-type-text">
                  Restrictions
                  <div className="admin-arrow-wrapper admin-arrow-wrapper-small ml-2">
                    <div className={restrictions ? 'admin-arrow-down' : 'admin-arrow-up'} />
                  </div>
                </div>
              </FormGroup>
              <FormGroup style={{display: restrictions ? 'block' : 'none'}}>
                <Col sm="12">Level</Col>
                <FormGroup>
                  <Row>
                    <Col sm="6">
                      <Label>From</Label>
                      <Input type="text" name="levelFrom" value={levelFrom} disabled={!restrictions} onChange={this.handleChange} onKeyDown={numbersOnly} />
                    </Col>
                    <Col sm="6">
                      <Label>To</Label>
                      <Input type="text" name="levelTo" value={levelTo} disabled={!restrictions} onChange={this.handleChange} onKeyDown={numbersOnly} />
                    </Col>
                  </Row>
                </FormGroup>
              </FormGroup>
              <FormGroup style={{display: restrictions ? 'block' : 'none'}}>
                <Col sm="12">Points</Col>
                <FormGroup>
                  <Row>
                    <Col sm="6">
                      <Label>From</Label>
                      <Input type="text" name="pointsFrom" value={pointsFrom} disabled={!restrictions} onChange={this.handleChange} onKeyDown={numbersOnlyWithMinus} />
                    </Col>
                    <Col sm="6">
                      <Label>To</Label>
                      <Input type="text" name="pointsTo" value={pointsTo} disabled={!restrictions} onChange={this.handleChange} onKeyDown={numbersOnlyWithMinus} />
                    </Col>
                  </Row>
                </FormGroup>
              </FormGroup>
              <FormGroup style={{display: restrictions ? 'block' : 'none'}}>
                <Col sm="12">Balance</Col>
                <FormGroup>
                  <Row>
                    <Col sm="6">
                      <Label>From</Label>
                      <Input type="text" name="balanceFrom" value={balanceFrom} disabled={!restrictions} onChange={this.handleChange} onKeyDown={numbersOnlyWithMinus} />
                    </Col>
                    <Col sm="6">
                      <Label>To</Label>
                      <Input type="text" name="balanceTo" value={balanceTo} disabled={!restrictions} onChange={this.handleChange} onKeyDown={numbersOnlyWithMinus} />
                    </Col>
                  </Row>
                </FormGroup>
              </FormGroup>
              <FormGroup style={{display: restrictions ? 'block' : 'none'}}>
                <Col sm="12">Played games</Col>
                <FormGroup>
                  <Row>
                    <Col sm="6">
                      <Label>From</Label>
                      <Input type="text" name="playedGamesFrom" value={playedGamesFrom} disabled={!restrictions} onChange={this.handleChange} onKeyDown={numbersOnly} />
                    </Col>
                    <Col sm="6">
                      <Label>To</Label>
                      <Input type="text" name="playedGamesTo" value={playedGamesTo} disabled={!restrictions} onChange={this.handleChange} onKeyDown={numbersOnly} />
                    </Col>
                  </Row>
                </FormGroup>
              </FormGroup>

              <FormGroup>
                <Label for="startDate">
                  Start Time
                </Label>
                <Row>
                  <Col md="12" className={repetitiveTournament && 'admin-date-time-picker-hide-date'}>
                    <DateTimePicker
                  //  time={false}
                      format={repetitiveTournament ? "HH:mm" : "DD.MM.YYYY HH:mm"}
                      culture="en"
                      onChange={this.ChangeStartDate}
                      value={startDate}
                      defaultValue={new Date()}
                      // min={new Date()}
                      step={30}
                      //currentDate={roundUpToNext30(new Date())}
                      // min={roundUpToNext30(new Date())}

                      // currentDate={repetitiveTournament ? dayStart : dayNext30}
                      min={repetitiveTournament ? dayStart : dayNext30}
                    />
                  </Col>
                  {/*  <Col md="6">
                  <DateTimePicker
                    date={false}
                    timeFormat="HH:mm"
                    culture="en"
                    onChange={this.ChangeStartTime}
                    value={startTime}
                    defaultValue={new Date()}
                  />
                </Col>  */}
                </Row>
              </FormGroup>
              {/* <FormGroup>
                <Label for="registerTime">
                  Registration time (min)
                </Label>
                <Input
                  type="number"
                  name="registerTime"
                  id="registerTime"
                  value={registerTime}
                  onChange={this.handleChange}
                  onKeyDown={numbersOnly}
                  onWheel={(e) => e.target.blur()}
                />
              </FormGroup> */}

              <FormGroup>
                <Label for="registerTime">
                  Registration time
                </Label>
                <Row>
                  <Col md="12" className={repetitiveTournament && 'admin-date-time-picker-hide-date'}>
                    <DateTimePicker
                      format={repetitiveTournament ? "HH:mm" : "DD.MM.YYYY HH:mm"}
                      culture="en"
                      onChange={this.changeRegisterDateTime}
                      value={registerDateTime}
                      defaultValue={new Date()}
                      // min={new Date()}
                      step={30}
                      // currentDate={roundUpToNext30(new Date())}
                      // min={roundUpToNext30(new Date())}

                      // currentDate={repetitiveTournament ? dayStart : dayNext30} // month switch prob
                      min={repetitiveTournament ? dayStart : dayNext30}

                    />
                    {maxLengthTime ? (
                      <div>
                        Maximum duration: {formatMinutes(maxLengthTime, 'en')}
                      </div>
                    ) : null}
                  </Col>
                </Row>
              </FormGroup>

              <FormGroup>
                <Label for="winnerPercent">
                  Winning Percent
                </Label>
                <Input
                  type="number"
                  name="winnerPercent"
                  id="winnerPercent"
                  value={winnerPercent}
                  onChange={(e) => {
                    const raw = e.target.value;

                    if (raw === '') {
                      this.setState({ winnerPercent: '' });
                      return;
                    }

                    if (raw.length === 3 && raw.substring(0, 2) !== '10') {
                      return;
                    }

                    const value = Math.min(100, Math.max(1, Number(raw)));
                    this.setState({ winnerPercent: value });
                  }}
                  onBlur={() => {
                    if (winnerPercent === '') {
                      this.setState({ winnerPercent: 1 });
                    }
                  }}
                  onKeyDown={numbersOnly}
                  onWheel={(e) => e.target.blur()}
                />
              </FormGroup>

              <FormGroup style={{ marginLeft: '20px' }}>
                <Input type="checkbox" name="more" checked={more} value={more} onChange={this.handleChange} readOnly/>
                <span className="checkmark" />
                <div className="game-type-text">
                  More

                  <div className="admin-arrow-wrapper admin-arrow-wrapper-small ml-2">
                    <div className={more ? 'admin-arrow-down' : 'admin-arrow-up'} />
                  </div>
                </div>
              </FormGroup>
              {more && (
                <Fragment>
                  <FormGroup className="tournaments-image-option">
                    <FileUploadImage
                      preview={sponsorPreview}
                      imageUrl={sponsorImageUrl}
                      showCrop={sponsorShowCrop}
                      hiddenFileInput={this.sponsorHiddenFileInput}
                      handleImageClick={this.sponsorHandleImageClick}
                      handleImageChange={this.handleImageChange}
                      handleEditPhoto={this.sponsorHandleEditPhoto}
                      uploadEventFile={this.uploadEventFile}
                      imageType={TOURNAMENT_OPTION_IMAGES.sponsor}
                      loading={loading}
                      handlePreviewPhoto={this.handlePreviewPhoto}
                      handleReSetImage={this.handleReSetImage}
                      handleReSetPreviewImage={this.handleReSetPreviewImage}
                    />
                    <FileUploadImage
                      preview={prizePreview}
                      imageUrl={prizeImageUrl}
                      showCrop={prizeShowCrop}
                      hiddenFileInput={this.prizeHiddenFileInput}
                      handleImageClick={this.prizeHandleImageClick}
                      handleImageChange={this.handleImageChange}
                      handleEditPhoto={this.prizeHandleEditPhoto}
                      uploadEventFile={this.uploadEventFile}
                      imageType={TOURNAMENT_OPTION_IMAGES.prize}
                      loading={loading}
                      handlePreviewPhoto={this.handlePreviewPhoto}
                      handleReSetImage={this.handleReSetImage}
                      handleReSetPreviewImage={this.handleReSetPreviewImage}
                    />
                  </FormGroup>

                  <FormGroup className="tournaments-image-option">
                    <div style={{width: '50%', display: 'flex', alignItems: 'start', justifyContent: 'center'}}>
                      <Label>
                        <Input type="checkbox" onClick={() => this.toggleBannerPrizeChecked()} checked={bannerPrizeChecked} readOnly />
                        <span className="checkmark" />
                        <div className="game-type-text">
                          Prize
                        </div>
                      </Label>
                    </div>
                    <FileUploadImage
                      preview={bannerPrizePreview}
                      imageUrl={bannerPrizeImageUrl}
                      showCrop={bannerPrizeShowCrop}
                      hiddenFileInput={this.bannerPrizeHiddenFileInput}
                      handleImageClick={this.bannerPrizeHandleImageClick}
                      handleImageChange={this.handleImageChange}
                      handleEditPhoto={this.bannerPrizeHandleEditPhoto}
                      uploadEventFile={this.uploadEventFile}
                      imageType={TOURNAMENT_OPTION_IMAGES.banner}
                      loading={loading}
                      handlePreviewPhoto={this.handlePreviewPhoto}
                      handleReSetImage={this.handleReSetImage}
                      handleReSetPreviewImage={this.handleReSetPreviewImage}
                      disabled={!bannerPrizeChecked}
                    />
                  </FormGroup>

                  <div style={bannerPrizeChecked ? {} : { opacity: '0.5', pointerEvents: 'none' }}>
                    <FormGroup>
                      <Label for="specialPrizeLV">
                        Special Prize (LV)
                      </Label>
                      <Input
                        type="text"
                        name="specialPrizeLV"
                        id="specialPrizeLV"
                        value={specialPrizeLV}
                        onChange={this.handleChange}
                        maxLength={100}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="specialPrizeEN">
                        Special Prize (EN)
                      </Label>
                      <Input
                        type="text"
                        name="specialPrizeEN"
                        id="specialPrizeEN"
                        value={specialPrizeEN}
                        onChange={this.handleChange}
                        maxLength={100}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="specialPrizeRU">
                        Special Prize (RU)
                      </Label>
                      <Input
                        type="text"
                        name="specialPrizeRU"
                        id="specialPrizeRU"
                        value={specialPrizeRU}
                        onChange={this.handleChange}
                        maxLength={100}
                      />
                    </FormGroup>
                  </div>

                  <FormGroup>
                    <Label for="maxPlayers">
                      Max Number of Players per Tournament
                    </Label>
                    <Input
                      type="text"
                      name="maxPlayers"
                      id="maxPlayers"
                      value={maxPlayers}
                      onChange={(e) => {
                        let value = e.target.value.replace(/\D/g, "").slice(0, 5);
                        this.setState({ maxPlayers: value });
                      }}

                      onKeyDown={numbersOnly}
                      onWheel={(e) => e.target.blur()}
                    />
                  </FormGroup>
                </Fragment>
              )}

              {/* <FormGroup>
                <Label style={{marginRight: 20}}>
                  <Input type="checkbox" onClick={() => this.toggleGameType('G')} checked={G} readOnly />
                  <span className="checkmark" />
                  <div className="game-type-text">
                    Show Banner
                  </div>
                </Label>
              </FormGroup> */}

              <FormGroup>
                <Label style={{ marginLeft: 20, display: 'inline-block' }}>
                  <Input type="checkbox" onClick={() => this.toggleBannerShowChecked()} checked={bannerShowChecked} readOnly />
                  <span className="checkmark" />
                  <div className="game-type-text">
                    Show banner
                  </div>
                </Label>
                <br />


                <Label for="startDate">
                  Banner Start Time
                </Label>
                <Row>
                  <Col md="12" className={repetitiveTournament && 'admin-date-time-picker-hide-date'} style={{opacity: bannerShowChecked ? 1 : 0.5}}>
                    <DateTimePicker
                      format={repetitiveTournament ? "HH:mm" : "DD.MM.YYYY HH:mm"}
                      culture="en"
                      onChange={this.ChangeBannerStartDate}
                      value={bannerStartDate}
                      defaultValue={new Date(Date.now() - 3 * 60 * 60 * 1000)}
                      // min={new Date()}
                      disabled={!bannerShowChecked}

                      step={30}
                      // currentDate={roundUpToNext30(new Date(Date.now() - 3 * 60 * 60 * 1000))}
                      // min={roundUpToNext30(new Date(Date.now() - 3 * 60 * 60 * 1000))}

                      // currentDate={repetitiveTournament ? dayStart : dayNext30before}
                      min={repetitiveTournament ? dayStart : dayNext30before}
                    />
                  </Col>
                </Row>
                <Label for="startDate">
                  Banner End Time
                </Label>
                <Row>
                  <Col md="12" className={repetitiveTournament && 'admin-date-time-picker-hide-date'} style={{opacity: 0.5}}>
                    <DateTimePicker
                      format={repetitiveTournament ? "HH:mm" : "DD.MM.YYYY HH:mm"}
                      culture="en"
                      onChange={this.ChangeBannerEndDate}
                      value={bannerEndDate}
                      defaultValue={new Date()}
                      min={new Date()}
                      disabled={true}
                    />
                  </Col>
                </Row>
              </FormGroup>

              <FormGroup>
                <Label style={{ marginLeft: 20, display: 'inline-block' }}>
                  <Input type="checkbox" onClick={() => this.toggleRepetitiveTournamentChecked()} checked={repetitiveTournament} readOnly />
                  <span className="checkmark" />
                  <div className="game-type-text">
                    Repetitive tournament
                  </div>
                </Label>
                <br />
                <div style={{position: 'relative', opacity: repetitiveTournament ? 1 : 0.5}}>
                  <DatePicker
                    value={multiDates}
                    minDate={new DateObject()}
                    onChange={(newVal) => {
                      if (newVal.length <= maxMultiDates) {
                        this.setState({ multiDates: newVal });
                      }
                    }}
                    closeOnSelect={false}
                    mapDays={({ date }) => {
                      const formattedDate = date.format();
                      const tooltipId = formattedDate.replaceAll('/', '-');//
                      const isSelected = multiDates.some((d) => d.format() === formattedDate);

                      if (!tournamentsPerDate[date]) return;
                      const hasOneTournament = tournamentsPerDate[date].length === 1;
                      const hasMoreTournaments = tournamentsPerDate[date].length > 1;

                      if (!isSelected) {
                        if (multiDates.length >= maxMultiDates) {
                          return {
                            disabled: true,
                            style: { color: 'gray', pointerEvents: 'none', opacity: 0.5 },
                          };
                        }
                      }
                      if (hasOneTournament || hasMoreTournaments) {
                        return {
                          style: { background: hasOneTournament ? '#ffd56b' : '#ff4d4d' },
                          id: `repetitive-tournament-${tooltipId}`,
                          children: (
                            <>
                              <span style={{pointerEvents: 'none'}}>{date.day}</span>
                              <UncontrolledPopover
                                popperClassName={`popover`}
                                placement="top"
                                trigger="hover"
                                target={`repetitive-tournament-${tooltipId}`}
                                style={{ pointerEvents: 'none' }}
                              >
                                <PopoverBody className="popover-body">
                                  {tournamentsPerDate[date].map(tournament => (
                                    <p key={`${tooltipId}-${tournament.time}`}>
                                      <b>{tournament.title}</b>: {tournament.time}
                                    </p>
                                  ))}
                                </PopoverBody>
                              </UncontrolledPopover>
                            </>
                          ),
                        };
                      }
                    }}
                    disabled={!repetitiveTournament}
                    format="DD/MM/YYYY"
                    multiple
                    plugins={[
                      // <TimePicker position="bottom" />,
                      <DatePanel markFocused />
                    ]}
                    containerClassName="admin-multidate-container"
                    ref={this.datePickerRef}
                  />

                  <div className="admin-multidate-container-overlay" id="multidate-button" onClick={this.toggleDatePicker} />

                  <UncontrolledPopover popperClassName={`popover`} placement="top" trigger="hover" target="multidate-button">
                    <PopoverBody className="popover-body">
                      Schedule plan
                    </PopoverBody>
                  </UncontrolledPopover>
                </div>
              </FormGroup>

            </Form>
          </ModalBody>
          <ModalFooter>
            {
              ableToSave ? (
                <Button color="primary" onClick={this.addTournament} disabled>Add Tournament</Button>
              ) : (
                <Button color="primary" onClick={this.addTournament}>Add Tournament</Button>
              )
            }
            {' '}
            <Button color="secondary" onClick={this.toggleAdd}>Close</Button>
          </ModalFooter>
        </Modal>

        <TournamentPlayers
          isOpen={openPlayersModal}
          toggle={() => this.setState({ openPlayersModal: false })}
          tournamentPlayersArr={tournamentPlayersArr}
          playersModalId={playersModalId}
          openPlayerHistoryModalFunc={this.openPlayerHistoryModalFunc}
          openChatModalFunc={this.openChatModalFunc}
          openChatModalMultipleFunc={this.openChatModalMultipleFunc}
          openedPlayerTournament={openedPlayerTournament}
          selectedUsers={selectedUsers}
          setSelectedUsers={(val) => this.setState({ selectedUsers: val })}
        />

        <PlayerHistory
          isOpen={openPlayerHistoryModal}
          toggle={this.togglePlayerHistory}
          tournamentPlayers={tournamentPlayers}
          playersModalId={playersModalId}
          playerHistoryId={playerHistoryId}
          tournamentPlayerHistory={tournamentPlayerHistory}
          setLeaveReasonModal={(value) => this.setState({ leaveReasonModal: value })}
        />

        <LeaveReason
          leaveReasonModal={leaveReasonModal}
          toggle={() => this.toggleLeaveReasonModal(null)}
        />

        <TournamentResults
          isOpen={openResultsModal}
          toggle={this.toggleResults}
          tournamentResults={tournamentResults}
          bots={bots}
        />

        <Chat
          openChatModal={openChatModal}
          setOpenChatModal={(value) => this.setState({ openChatModal: value })}
          openChatModalName={openChatModalName}
          setOpenChatModalName={(value) => this.setState({ openChatModalName: value })}
          openChatModalUid={openChatModalUid}
          setOpenChatModalUid={(value) => this.setState({ openChatModalUid: value })}
          showNotification={showNotification}

          openChatModalMultiple={openChatModalMultiple}
          selectedUsers={selectedUsers}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  tournamentResults: state.admin.tournamentResults || [],
  tournamentPlayersArr: state.admin.tournamentPlayersArr || [],
});

const mapDispatchToProps = {
  supportAMessageFileUpload: supportMessageFileUpload,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('admin')(AllBans));
